function PlanB({ ...props }) {
	return (
		<g {...props} id="unit-b">
			<g id="furniture">
				<polyline
					points="133.72 763.86 133.72 761.78 137.81 761.78 137.81 763.86 133.72 763.86"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="82.18 759.71 82.18 581.07 127.1 581.07 127.1 759.71 82.18 759.71"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="592.95 470.99 761.05 470.99 761.05 442.9 592.95 442.9 592.95 470.99"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="592.95"
					y1="442.9"
					x2="592.95"
					y2="470.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.05"
					y1="442.9"
					x2="592.95"
					y2="442.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.05"
					y1="470.99"
					x2="761.05"
					y2="442.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="592.95"
					y1="470.99"
					x2="761.05"
					y2="470.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="592.95"
					y1="470.99"
					x2="596.58"
					y2="470.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="599.27"
					y1="470.99"
					x2="603.77"
					y2="470.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="606.46"
					y1="470.99"
					x2="610.95"
					y2="470.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="613.65"
					y1="470.99"
					x2="618.14"
					y2="470.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="620.84"
					y1="470.99"
					x2="625.33"
					y2="470.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="628.03"
					y1="470.99"
					x2="632.52"
					y2="470.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="635.21"
					y1="470.99"
					x2="639.71"
					y2="470.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="642.4"
					y1="470.99"
					x2="646.9"
					y2="470.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="649.59"
					y1="470.99"
					x2="654.08"
					y2="470.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="656.78"
					y1="470.99"
					x2="661.27"
					y2="470.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="663.97"
					y1="470.99"
					x2="668.46"
					y2="470.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.16"
					y1="470.99"
					x2="675.65"
					y2="470.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="678.34"
					y1="470.99"
					x2="682.84"
					y2="470.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="685.53"
					y1="470.99"
					x2="690.02"
					y2="470.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.72"
					y1="470.99"
					x2="697.21"
					y2="470.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="699.91"
					y1="470.99"
					x2="704.4"
					y2="470.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.1"
					y1="470.99"
					x2="711.59"
					y2="470.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="714.28"
					y1="470.99"
					x2="718.78"
					y2="470.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.47"
					y1="470.99"
					x2="725.97"
					y2="470.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="728.66"
					y1="470.99"
					x2="733.15"
					y2="470.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.85"
					y1="470.99"
					x2="740.34"
					y2="470.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.04"
					y1="470.99"
					x2="747.53"
					y2="470.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="750.22"
					y1="470.99"
					x2="754.72"
					y2="470.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="757.41"
					y1="470.99"
					x2="761.05"
					y2="470.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.05"
					y1="470.99"
					x2="761.05"
					y2="466.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.05"
					y1="463.72"
					x2="761.05"
					y2="459.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.05"
					y1="456.53"
					x2="761.05"
					y2="452.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.05"
					y1="449.35"
					x2="761.05"
					y2="444.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.05"
					y1="444.78"
					x2="757.41"
					y2="444.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.72"
					y1="444.78"
					x2="750.22"
					y2="444.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="747.53"
					y1="444.78"
					x2="743.04"
					y2="444.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.34"
					y1="444.78"
					x2="735.85"
					y2="444.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="733.15"
					y1="444.78"
					x2="728.66"
					y2="444.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.97"
					y1="444.78"
					x2="721.47"
					y2="444.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="718.78"
					y1="444.78"
					x2="714.28"
					y2="444.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="711.59"
					y1="444.78"
					x2="707.1"
					y2="444.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.4"
					y1="444.78"
					x2="699.91"
					y2="444.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="697.21"
					y1="444.78"
					x2="692.72"
					y2="444.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="690.02"
					y1="444.78"
					x2="685.53"
					y2="444.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="682.84"
					y1="444.78"
					x2="678.34"
					y2="444.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="675.65"
					y1="444.78"
					x2="671.16"
					y2="444.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="668.46"
					y1="444.78"
					x2="663.97"
					y2="444.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="661.27"
					y1="444.78"
					x2="656.78"
					y2="444.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="654.08"
					y1="444.78"
					x2="649.59"
					y2="444.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="646.9"
					y1="444.78"
					x2="642.4"
					y2="444.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="639.71"
					y1="444.78"
					x2="635.21"
					y2="444.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="632.52"
					y1="444.78"
					x2="628.03"
					y2="444.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="625.33"
					y1="444.78"
					x2="620.84"
					y2="444.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.14"
					y1="444.78"
					x2="613.65"
					y2="444.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="610.95"
					y1="444.78"
					x2="606.46"
					y2="444.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="603.77"
					y1="444.78"
					x2="599.27"
					y2="444.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.58"
					y1="444.78"
					x2="592.95"
					y2="444.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="592.95"
					y1="444.78"
					x2="592.95"
					y2="449.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="592.95"
					y1="452.04"
					x2="592.95"
					y2="456.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="592.95"
					y1="459.23"
					x2="592.95"
					y2="463.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="592.95"
					y1="466.42"
					x2="592.95"
					y2="470.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.69"
					y1="674.29"
					x2="271.69"
					y2="730.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="299.77"
					y1="674.29"
					x2="271.69"
					y2="674.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="299.77"
					y1="730.28"
					x2="299.77"
					y2="728.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="299.77"
					y1="726.1"
					x2="299.77"
					y2="721.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="299.77"
					y1="718.91"
					x2="299.77"
					y2="714.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="299.77"
					y1="690.16"
					x2="299.77"
					y2="685.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="299.77"
					y1="682.97"
					x2="299.77"
					y2="678.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="299.77"
					y1="675.78"
					x2="299.77"
					y2="674.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="299.77"
					y1="674.29"
					x2="295.2"
					y2="674.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="292.51"
					y1="674.29"
					x2="288.02"
					y2="674.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="285.32"
					y1="674.29"
					x2="280.83"
					y2="674.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="278.13"
					y1="674.29"
					x2="273.56"
					y2="674.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="273.56"
					y1="674.29"
					x2="273.56"
					y2="675.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="273.56"
					y1="678.48"
					x2="273.56"
					y2="682.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="273.56"
					y1="685.67"
					x2="273.56"
					y2="690.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="273.56"
					y1="692.85"
					x2="273.56"
					y2="697.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="273.56"
					y1="700.04"
					x2="273.56"
					y2="704.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="273.56"
					y1="707.23"
					x2="273.56"
					y2="711.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="273.56"
					y1="714.42"
					x2="273.56"
					y2="718.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="273.56"
					y1="721.61"
					x2="273.56"
					y2="726.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="273.56"
					y1="728.79"
					x2="273.56"
					y2="730.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="273.56"
					y1="730.28"
					x2="278.13"
					y2="730.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="280.83"
					y1="730.28"
					x2="285.32"
					y2="730.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="288.02"
					y1="730.28"
					x2="292.51"
					y2="730.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="295.2"
					y1="730.28"
					x2="299.77"
					y2="730.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="257.16 746.49 303.41 746.49 303.41 792.75 257.16 792.75 257.16 746.49"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="201.11 176.67 201.11 178.54 124.52 178.54 124.52 176.67 201.11 176.67"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="201.11"
					y1="176.67"
					x2="201.11"
					y2="178.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="201.11"
					y1="178.54"
					x2="124.52"
					y2="178.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="124.52"
					y1="178.54"
					x2="124.52"
					y2="176.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="124.52"
					y1="176.67"
					x2="201.11"
					y2="176.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="238.78 175.93 207.77 175.93 207.77 179.98 238.78 179.98 238.78 175.93"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="206.29 175.56 240.26 175.56 240.26 175.93 206.29 175.93 206.29 175.56"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="206.29"
					y1="175.56"
					x2="240.26"
					y2="175.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="240.26"
					y1="175.56"
					x2="240.26"
					y2="175.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="240.26"
					y1="175.93"
					x2="206.29"
					y2="175.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.29"
					y1="175.93"
					x2="206.29"
					y2="175.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="238.78"
					y1="179.98"
					x2="207.77"
					y2="179.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="207.77"
					y1="175.93"
					x2="238.78"
					y2="175.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="242.1 179.98 238.78 179.98 238.78 175.93 242.1 175.93 242.1 179.98"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="242.1"
					y1="179.98"
					x2="238.78"
					y2="179.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="238.78"
					y1="179.98"
					x2="238.78"
					y2="175.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="238.78"
					y1="175.93"
					x2="242.1"
					y2="175.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="242.1"
					y1="175.93"
					x2="242.1"
					y2="179.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="204.45 175.93 207.77 175.93 207.77 179.98 204.45 179.98 204.45 175.93"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="204.45"
					y1="175.93"
					x2="207.77"
					y2="175.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="207.77"
					y1="175.93"
					x2="207.77"
					y2="179.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="207.77"
					y1="179.98"
					x2="204.45"
					y2="179.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="204.45"
					y1="179.98"
					x2="204.45"
					y2="175.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="238.78"
					y1="176.67"
					x2="207.77"
					y2="176.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="243.57 179.61 242.1 179.61 242.1 175.93 240.26 175.93 240.26 175.56 243.57 175.56 243.57 179.61"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="243.57"
					y1="179.61"
					x2="242.1"
					y2="179.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="242.1"
					y1="179.61"
					x2="242.1"
					y2="175.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="242.1"
					y1="175.93"
					x2="240.26"
					y2="175.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="240.26"
					y1="175.93"
					x2="240.26"
					y2="175.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="240.26"
					y1="175.56"
					x2="243.57"
					y2="175.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="243.57"
					y1="175.56"
					x2="243.57"
					y2="179.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="202.98 175.56 206.29 175.56 206.29 175.93 204.45 175.93 204.45 179.61 202.98 179.61 202.98 175.56"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="202.98"
					y1="175.56"
					x2="206.29"
					y2="175.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.29"
					y1="175.56"
					x2="206.29"
					y2="175.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.29"
					y1="175.93"
					x2="204.45"
					y2="175.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="204.45"
					y1="175.93"
					x2="204.45"
					y2="179.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="204.45"
					y1="179.61"
					x2="202.98"
					y2="179.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="202.98"
					y1="179.61"
					x2="202.98"
					y2="175.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="199.23 176.67 202.98 176.67 202.98 187.9 199.23 187.9 199.23 176.67"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="202.98"
					y1="176.67"
					x2="199.23"
					y2="176.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="202.98"
					y1="187.9"
					x2="202.98"
					y2="176.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="199.23"
					y1="187.9"
					x2="202.98"
					y2="187.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="199.23"
					y1="176.67"
					x2="199.23"
					y2="187.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="247.32 176.67 247.32 187.9 243.57 187.9 243.57 176.67 247.32 176.67"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="247.32"
					y1="187.9"
					x2="247.32"
					y2="176.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="243.57"
					y1="187.9"
					x2="247.32"
					y2="187.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="243.57"
					y1="176.67"
					x2="243.57"
					y2="187.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.32"
					y1="176.67"
					x2="243.57"
					y2="176.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="122.65 176.67 126.39 176.67 126.39 187.9 122.65 187.9 122.65 176.67"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="126.39"
					y1="176.67"
					x2="122.65"
					y2="176.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="126.39"
					y1="187.9"
					x2="126.39"
					y2="176.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="122.65"
					y1="187.9"
					x2="126.39"
					y2="187.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="122.65"
					y1="176.67"
					x2="122.65"
					y2="187.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="424.7 176.67 424.7 178.54 348.61 178.54 348.61 176.67 424.7 176.67"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="424.7"
					y1="176.67"
					x2="424.7"
					y2="178.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="424.7"
					y1="178.54"
					x2="348.61"
					y2="178.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.61"
					y1="178.54"
					x2="348.61"
					y2="176.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.61"
					y1="176.67"
					x2="424.7"
					y2="176.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="459.12 175.93 431.36 175.93 431.36 179.98 459.12 179.98 459.12 175.93"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="429.89 175.56 460.6 175.56 460.6 175.93 429.89 175.93 429.89 175.56"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="429.89"
					y1="175.56"
					x2="460.6"
					y2="175.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.6"
					y1="175.56"
					x2="460.6"
					y2="175.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.6"
					y1="175.93"
					x2="429.89"
					y2="175.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="429.89"
					y1="175.93"
					x2="429.89"
					y2="175.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.12"
					y1="179.98"
					x2="431.36"
					y2="179.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="431.36"
					y1="175.93"
					x2="459.12"
					y2="175.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="462.44 179.98 459.12 179.98 459.12 175.93 462.44 175.93 462.44 179.98"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="462.44"
					y1="179.98"
					x2="459.12"
					y2="179.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.12"
					y1="179.98"
					x2="459.12"
					y2="175.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.12"
					y1="175.93"
					x2="462.44"
					y2="175.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="462.44"
					y1="175.93"
					x2="462.44"
					y2="179.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="428.04 175.93 431.36 175.93 431.36 179.98 428.04 179.98 428.04 175.93"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="428.04"
					y1="175.93"
					x2="431.36"
					y2="175.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="431.36"
					y1="175.93"
					x2="431.36"
					y2="179.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="431.36"
					y1="179.98"
					x2="428.04"
					y2="179.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="428.04"
					y1="179.98"
					x2="428.04"
					y2="175.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.12"
					y1="176.67"
					x2="431.36"
					y2="176.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="463.92 179.61 462.44 179.61 462.44 175.93 460.6 175.93 460.6 175.56 463.92 175.56 463.92 179.61"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="463.92"
					y1="179.61"
					x2="462.44"
					y2="179.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="462.44"
					y1="179.61"
					x2="462.44"
					y2="175.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="462.44"
					y1="175.93"
					x2="460.6"
					y2="175.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.6"
					y1="175.93"
					x2="460.6"
					y2="175.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.6"
					y1="175.56"
					x2="463.92"
					y2="175.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.92"
					y1="175.56"
					x2="463.92"
					y2="179.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="426.57 175.56 429.89 175.56 429.89 175.93 428.04 175.93 428.04 179.61 426.57 179.61 426.57 175.56"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="426.57"
					y1="175.56"
					x2="429.89"
					y2="175.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="429.89"
					y1="175.56"
					x2="429.89"
					y2="175.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="429.89"
					y1="175.93"
					x2="428.04"
					y2="175.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="428.04"
					y1="175.93"
					x2="428.04"
					y2="179.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="428.04"
					y1="179.61"
					x2="426.57"
					y2="179.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="426.57"
					y1="179.61"
					x2="426.57"
					y2="175.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="467.66 176.67 467.66 187.9 463.92 187.9 463.92 176.67 467.66 176.67"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="467.66"
					y1="187.9"
					x2="467.66"
					y2="176.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.92"
					y1="187.9"
					x2="467.66"
					y2="187.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.92"
					y1="176.67"
					x2="463.92"
					y2="187.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="467.66"
					y1="176.67"
					x2="463.92"
					y2="176.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="422.82 176.67 426.57 176.67 426.57 187.9 422.82 187.9 422.82 176.67"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="426.57"
					y1="176.67"
					x2="422.82"
					y2="176.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="426.57"
					y1="187.9"
					x2="426.57"
					y2="176.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="422.82"
					y1="187.9"
					x2="426.57"
					y2="187.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="422.82"
					y1="176.67"
					x2="422.82"
					y2="187.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="346.73 176.67 350.48 176.67 350.48 187.9 346.73 187.9 346.73 176.67"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="350.48"
					y1="176.67"
					x2="346.73"
					y2="176.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="350.48"
					y1="187.9"
					x2="350.48"
					y2="176.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="346.73"
					y1="187.9"
					x2="350.48"
					y2="187.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="346.73"
					y1="176.67"
					x2="346.73"
					y2="187.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="676.68 176.67 676.68 178.54 577.99 178.54 577.99 176.67 676.68 176.67"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="676.68"
					y1="176.67"
					x2="676.68"
					y2="178.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="676.68"
					y1="178.54"
					x2="577.99"
					y2="178.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="577.99"
					y1="178.54"
					x2="577.99"
					y2="176.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="577.99"
					y1="176.67"
					x2="676.68"
					y2="176.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="714.36 175.93 683.34 175.93 683.34 179.98 714.36 179.98 714.36 175.93"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="681.86 175.56 715.83 175.56 715.83 175.93 681.86 175.93 681.86 175.56"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="681.86"
					y1="175.56"
					x2="715.83"
					y2="175.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="715.83"
					y1="175.56"
					x2="715.83"
					y2="175.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="715.83"
					y1="175.93"
					x2="681.86"
					y2="175.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="681.86"
					y1="175.93"
					x2="681.86"
					y2="175.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="714.36"
					y1="179.98"
					x2="683.34"
					y2="179.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="683.34"
					y1="175.93"
					x2="714.36"
					y2="175.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="717.67 179.98 714.36 179.98 714.36 175.93 717.67 175.93 717.67 179.98"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="717.67"
					y1="179.98"
					x2="714.36"
					y2="179.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="714.36"
					y1="179.98"
					x2="714.36"
					y2="175.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="714.36"
					y1="175.93"
					x2="717.67"
					y2="175.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.67"
					y1="175.93"
					x2="717.67"
					y2="179.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="680.02 175.93 683.34 175.93 683.34 179.98 680.02 179.98 680.02 175.93"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="680.02"
					y1="175.93"
					x2="683.34"
					y2="175.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="683.34"
					y1="175.93"
					x2="683.34"
					y2="179.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="683.34"
					y1="179.98"
					x2="680.02"
					y2="179.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="680.02"
					y1="179.98"
					x2="680.02"
					y2="175.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="714.36"
					y1="176.67"
					x2="683.34"
					y2="176.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="719.14 179.61 717.67 179.61 717.67 175.93 715.83 175.93 715.83 175.56 719.14 175.56 719.14 179.61"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="719.14"
					y1="179.61"
					x2="717.67"
					y2="179.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.67"
					y1="179.61"
					x2="717.67"
					y2="175.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.67"
					y1="175.93"
					x2="715.83"
					y2="175.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="715.83"
					y1="175.93"
					x2="715.83"
					y2="175.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="715.83"
					y1="175.56"
					x2="719.14"
					y2="175.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="719.14"
					y1="175.56"
					x2="719.14"
					y2="179.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="678.55 175.56 681.86 175.56 681.86 175.93 680.02 175.93 680.02 179.61 678.55 179.61 678.55 175.56"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="678.55"
					y1="175.56"
					x2="681.86"
					y2="175.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="681.86"
					y1="175.56"
					x2="681.86"
					y2="175.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="681.86"
					y1="175.93"
					x2="680.02"
					y2="175.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="680.02"
					y1="175.93"
					x2="680.02"
					y2="179.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="680.02"
					y1="179.61"
					x2="678.55"
					y2="179.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="678.55"
					y1="179.61"
					x2="678.55"
					y2="175.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="674.81 176.67 678.55 176.67 678.55 187.9 674.81 187.9 674.81 176.67"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="678.55"
					y1="176.67"
					x2="674.81"
					y2="176.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="678.55"
					y1="187.9"
					x2="678.55"
					y2="176.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.81"
					y1="187.9"
					x2="678.55"
					y2="187.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.81"
					y1="176.67"
					x2="674.81"
					y2="187.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="722.89 176.67 722.89 187.9 719.14 187.9 719.14 176.67 722.89 176.67"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="722.89"
					y1="187.9"
					x2="722.89"
					y2="176.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="719.14"
					y1="187.9"
					x2="722.89"
					y2="187.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="719.14"
					y1="176.67"
					x2="719.14"
					y2="187.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="722.89"
					y1="176.67"
					x2="719.14"
					y2="176.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="576.12 176.67 579.86 176.67 579.86 187.9 576.12 187.9 576.12 176.67"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="579.86"
					y1="176.67"
					x2="576.12"
					y2="176.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="579.86"
					y1="187.9"
					x2="579.86"
					y2="176.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.12"
					y1="187.9"
					x2="579.86"
					y2="187.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.12"
					y1="176.67"
					x2="576.12"
					y2="187.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="772.28 280.26 770.4 280.26 770.4 219.32 772.28 219.32 772.28 280.26"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="772.28"
					y1="280.26"
					x2="770.4"
					y2="280.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="770.4"
					y1="280.26"
					x2="770.4"
					y2="219.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="770.4"
					y1="219.32"
					x2="772.28"
					y2="219.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.28"
					y1="219.32"
					x2="772.28"
					y2="280.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="772.28 342.29 770.4 342.29 770.4 280.26 772.28 280.26 772.28 342.29"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="772.28"
					y1="342.29"
					x2="770.4"
					y2="342.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="770.4"
					y1="342.29"
					x2="770.4"
					y2="280.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="770.4"
					y1="280.26"
					x2="772.28"
					y2="280.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.28"
					y1="280.26"
					x2="772.28"
					y2="342.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="781.86 405.57 827.79 405.57 827.79 409.25 781.86 409.25 781.86 405.57"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="781.86"
					y1="405.57"
					x2="827.79"
					y2="405.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="827.79"
					y1="405.57"
					x2="827.79"
					y2="409.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="827.79"
					y1="409.25"
					x2="781.86"
					y2="409.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.86"
					y1="409.25"
					x2="781.86"
					y2="405.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.86"
					y1="408.52"
					x2="827.79"
					y2="408.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.86"
					y1="409.25"
					x2="827.79"
					y2="409.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.86"
					y1="405.57"
					x2="827.79"
					y2="405.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="773.01 405.57 781.86 405.57 781.86 409.25 773.01 409.25 773.01 405.57"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="773.01"
					y1="405.57"
					x2="781.86"
					y2="405.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.86"
					y1="405.57"
					x2="781.86"
					y2="409.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.86"
					y1="409.25"
					x2="773.01"
					y2="409.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773.01"
					y1="409.25"
					x2="773.01"
					y2="405.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="827.79 405.57 836.64 405.57 836.64 409.25 827.79 409.25 827.79 405.57"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="827.79"
					y1="405.57"
					x2="836.64"
					y2="405.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="836.64"
					y1="405.57"
					x2="836.64"
					y2="409.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="836.64"
					y1="409.25"
					x2="827.79"
					y2="409.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="827.79"
					y1="409.25"
					x2="827.79"
					y2="405.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="768.96 410.73 768.96 407.41 769.33 407.41 769.33 409.25 773.01 409.25 773.01 410.73 768.96 410.73"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="768.96"
					y1="410.73"
					x2="768.96"
					y2="407.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="768.96"
					y1="407.41"
					x2="769.33"
					y2="407.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.33"
					y1="407.41"
					x2="769.33"
					y2="409.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.33"
					y1="409.25"
					x2="773.01"
					y2="409.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773.01"
					y1="409.25"
					x2="773.01"
					y2="410.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773.01"
					y1="410.73"
					x2="768.96"
					y2="410.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="773.01 344.16 773.01 345.63 769.33 345.63 769.33 347.48 768.96 347.48 768.96 344.16 773.01 344.16"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="773.01"
					y1="344.16"
					x2="773.01"
					y2="345.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773.01"
					y1="345.63"
					x2="769.33"
					y2="345.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.33"
					y1="345.63"
					x2="769.33"
					y2="347.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.33"
					y1="347.48"
					x2="768.96"
					y2="347.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="768.96"
					y1="347.48"
					x2="768.96"
					y2="344.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="768.96"
					y1="344.16"
					x2="773.01"
					y2="344.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="772.28 340.42 772.28 344.16 761.05 344.16 761.05 340.42 772.28 340.42"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="772.28"
					y1="344.16"
					x2="772.28"
					y2="340.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.05"
					y1="344.16"
					x2="772.28"
					y2="344.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.05"
					y1="340.42"
					x2="761.05"
					y2="344.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.28"
					y1="340.42"
					x2="761.05"
					y2="340.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="772.28 278.39 772.28 282.13 761.05 282.13 761.05 278.39 772.28 278.39"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="772.28"
					y1="282.13"
					x2="772.28"
					y2="278.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.05"
					y1="282.13"
					x2="772.28"
					y2="282.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.05"
					y1="278.39"
					x2="761.05"
					y2="282.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.28"
					y1="278.39"
					x2="761.05"
					y2="278.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="772.28 217.45 772.28 221.19 761.05 221.19 761.05 217.45 772.28 217.45"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="772.28"
					y1="221.19"
					x2="772.28"
					y2="217.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.05"
					y1="221.19"
					x2="772.28"
					y2="221.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.05"
					y1="217.45"
					x2="761.05"
					y2="221.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.28"
					y1="217.45"
					x2="761.05"
					y2="217.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="772.28 414.47 761.05 414.47 761.05 410.73 772.28 410.73 772.28 414.47"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="761.05"
					y1="414.47"
					x2="772.28"
					y2="414.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.05"
					y1="410.73"
					x2="761.05"
					y2="414.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.28"
					y1="410.73"
					x2="761.05"
					y2="410.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.28"
					y1="414.47"
					x2="772.28"
					y2="410.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="142.53"
					y1="836.91"
					x2="139.72"
					y2="836.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="142.53"
					y1="821.93"
					x2="139.72"
					y2="821.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="142.53"
					y1="821.93"
					x2="142.53"
					y2="836.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="213.66"
					y1="836.91"
					x2="216.47"
					y2="836.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="213.66"
					y1="821.93"
					x2="216.47"
					y2="821.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="213.66"
					y1="821.93"
					x2="213.66"
					y2="836.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="142.53"
					y1="821.93"
					x2="64.98"
					y2="821.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<polyline
					points="212.72 837.84 216.47 837.84 216.47 836.91 212.72 836.91 212.72 837.84"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="143.46 836.91 139.72 836.91 139.72 837.84 143.46 837.84 143.46 836.91"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="212.72 821.93 216.47 821.93 216.47 821 212.72 821 212.72 821.93"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="143.46 821 139.72 821 139.72 821.93 143.46 821.93 143.46 821"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="212.72"
					y1="837.84"
					x2="216.47"
					y2="837.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.47"
					y1="837.84"
					x2="216.47"
					y2="836.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.47"
					y1="836.91"
					x2="212.72"
					y2="836.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="212.72"
					y1="836.91"
					x2="212.72"
					y2="837.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="143.46"
					y1="836.91"
					x2="139.72"
					y2="836.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="139.72"
					y1="836.91"
					x2="139.72"
					y2="837.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="139.72"
					y1="837.84"
					x2="143.46"
					y2="837.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="143.46"
					y1="837.84"
					x2="143.46"
					y2="836.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="212.72"
					y1="821.93"
					x2="216.47"
					y2="821.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.47"
					y1="821.93"
					x2="216.47"
					y2="821"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.47"
					y1="821"
					x2="212.72"
					y2="821"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="212.72"
					y1="821"
					x2="212.72"
					y2="821.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="143.46"
					y1="821"
					x2="139.72"
					y2="821"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="139.72"
					y1="821"
					x2="139.72"
					y2="821.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="139.72"
					y1="821.93"
					x2="143.46"
					y2="821.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="143.46"
					y1="821.93"
					x2="143.46"
					y2="821"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="211.79 836.91 213.19 836.91 213.19 821.93 211.79 821.93 211.79 836.91"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="142.99 836.91 144.4 836.91 144.4 821.93 142.99 821.93 142.99 836.91"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="192.05 774.28 144.4 821.93 146.71 824.25 194.37 776.6 192.05 774.28"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="213.19"
					y1="821.93"
					x2="213.66"
					y2="821.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.19"
					y1="836.91"
					x2="213.66"
					y2="836.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.66"
					y1="821.93"
					x2="213.66"
					y2="836.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="142.99"
					y1="821.93"
					x2="142.53"
					y2="821.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="142.99"
					y1="836.91"
					x2="142.53"
					y2="836.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="142.53"
					y1="821.93"
					x2="142.53"
					y2="836.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.79"
					y1="836.91"
					x2="211.79"
					y2="821.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.79"
					y1="821.93"
					x2="213.19"
					y2="821.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.19"
					y1="821.93"
					x2="213.19"
					y2="836.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.19"
					y1="836.91"
					x2="211.79"
					y2="836.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="142.99"
					y1="836.91"
					x2="142.99"
					y2="821.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="142.99"
					y1="821.93"
					x2="144.4"
					y2="821.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="144.4"
					y1="821.93"
					x2="144.4"
					y2="836.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="144.4"
					y1="836.91"
					x2="142.99"
					y2="836.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.05"
					y1="774.28"
					x2="194.37"
					y2="776.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.37"
					y1="776.6"
					x2="146.71"
					y2="824.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="146.71"
					y1="824.25"
					x2="144.4"
					y2="821.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="144.4"
					y1="821.93"
					x2="192.05"
					y2="774.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.66"
					y1="821.93"
					x2="213.66"
					y2="836.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="213.66"
					y1="821.93"
					x2="213.66"
					y2="836.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="213.66"
					y1="821.93"
					x2="216.47"
					y2="821.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="213.66"
					y1="821.93"
					x2="216.47"
					y2="821.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="213.66"
					y1="836.91"
					x2="216.47"
					y2="836.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="213.66"
					y1="836.91"
					x2="216.47"
					y2="836.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="142.53"
					y1="821.93"
					x2="142.53"
					y2="836.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="142.53"
					y1="821.93"
					x2="142.53"
					y2="836.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="142.53"
					y1="821.93"
					x2="139.72"
					y2="821.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="142.53"
					y1="821.93"
					x2="139.72"
					y2="821.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="142.53"
					y1="836.91"
					x2="139.72"
					y2="836.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="142.53"
					y1="836.91"
					x2="139.72"
					y2="836.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="354.87"
					y1="607.25"
					x2="354"
					y2="607.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="761.05"
					y1="470.99"
					x2="592.95"
					y2="470.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="776.02"
					y1="414.47"
					x2="761.05"
					y2="414.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="761.05"
					y1="414.47"
					x2="761.05"
					y2="418.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="761.05"
					y1="427.58"
					x2="761.05"
					y2="470.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="722.89"
					y1="172.92"
					x2="722.89"
					y2="187.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="82.18"
					y1="759.71"
					x2="67.2"
					y2="759.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="64.98"
					y1="759.71"
					x2="67.2"
					y2="759.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="64.98"
					y1="821.93"
					x2="64.98"
					y2="759.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="941.46"
					y1="451.26"
					x2="776.02"
					y2="451.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="253.94"
					y1="796.15"
					x2="253.94"
					y2="798.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="244.58"
					y1="796.15"
					x2="244.58"
					y2="798.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="244.58"
					y1="796.15"
					x2="253.94"
					y2="796.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="253.94"
					y1="743.74"
					x2="253.94"
					y2="740.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="244.58"
					y1="743.74"
					x2="244.58"
					y2="740.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="244.58"
					y1="743.74"
					x2="253.94"
					y2="743.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="244.58"
					y1="739.64"
					x2="244.58"
					y2="743.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="253.94"
					y1="800.07"
					x2="253.94"
					y2="796.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="253.94"
					y1="743.74"
					x2="253.94"
					y2="739.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<polyline
					points="254.88 744.68 254.88 740.93 253.94 740.93 253.94 744.68 254.88 744.68"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="253.94 795.22 253.94 798.96 254.88 798.96 254.88 795.22 253.94 795.22"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="244.58 744.68 244.58 740.93 243.65 740.93 243.65 744.68 244.58 744.68"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="243.65 795.22 243.65 798.96 244.58 798.96 244.58 795.22 243.65 795.22"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="254.88"
					y1="744.68"
					x2="254.88"
					y2="740.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.88"
					y1="740.93"
					x2="253.94"
					y2="740.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="253.94"
					y1="740.93"
					x2="253.94"
					y2="744.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="253.94"
					y1="744.68"
					x2="254.88"
					y2="744.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="253.94"
					y1="795.22"
					x2="253.94"
					y2="798.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="253.94"
					y1="798.96"
					x2="254.88"
					y2="798.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.88"
					y1="798.96"
					x2="254.88"
					y2="795.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.88"
					y1="795.22"
					x2="253.94"
					y2="795.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="244.58"
					y1="744.68"
					x2="244.58"
					y2="740.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="244.58"
					y1="740.93"
					x2="243.65"
					y2="740.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="243.65"
					y1="740.93"
					x2="243.65"
					y2="744.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="243.65"
					y1="744.68"
					x2="244.58"
					y2="744.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="243.65"
					y1="795.22"
					x2="243.65"
					y2="798.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="243.65"
					y1="798.96"
					x2="244.58"
					y2="798.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="244.58"
					y1="798.96"
					x2="244.58"
					y2="795.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="244.58"
					y1="795.22"
					x2="243.65"
					y2="795.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="253.94 745.61 253.94 744.21 244.58 744.21 244.58 745.61 253.94 745.61"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="253.94 795.69 253.94 794.28 244.58 794.28 244.58 795.69 253.94 795.69"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="210.17 759.87 244.58 794.28 246.9 791.97 212.48 757.55 210.17 759.87"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="244.58"
					y1="744.21"
					x2="244.58"
					y2="743.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="253.94"
					y1="744.21"
					x2="253.94"
					y2="743.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="244.58"
					y1="743.74"
					x2="253.94"
					y2="743.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="244.58"
					y1="795.69"
					x2="244.58"
					y2="796.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="253.94"
					y1="795.69"
					x2="253.94"
					y2="796.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="244.58"
					y1="796.15"
					x2="253.94"
					y2="796.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="253.94"
					y1="745.61"
					x2="244.58"
					y2="745.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="244.58"
					y1="745.61"
					x2="244.58"
					y2="744.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="244.58"
					y1="744.21"
					x2="253.94"
					y2="744.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="253.94"
					y1="744.21"
					x2="253.94"
					y2="745.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="253.94"
					y1="795.69"
					x2="244.58"
					y2="795.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="244.58"
					y1="795.69"
					x2="244.58"
					y2="794.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="244.58"
					y1="794.28"
					x2="253.94"
					y2="794.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="253.94"
					y1="794.28"
					x2="253.94"
					y2="795.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="210.17"
					y1="759.87"
					x2="212.48"
					y2="757.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="212.48"
					y1="757.55"
					x2="246.9"
					y2="791.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="246.9"
					y1="791.97"
					x2="244.58"
					y2="794.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="244.58"
					y1="794.28"
					x2="210.17"
					y2="759.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="244.58"
					y1="743.74"
					x2="253.94"
					y2="743.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="244.58"
					y1="743.74"
					x2="253.94"
					y2="743.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="244.58"
					y1="743.74"
					x2="244.58"
					y2="740.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="244.58"
					y1="743.74"
					x2="244.58"
					y2="740.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="253.94"
					y1="743.74"
					x2="253.94"
					y2="740.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="253.94"
					y1="743.74"
					x2="253.94"
					y2="740.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="244.58"
					y1="796.15"
					x2="253.94"
					y2="796.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="244.58"
					y1="796.15"
					x2="253.94"
					y2="796.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="244.58"
					y1="796.15"
					x2="244.58"
					y2="798.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="244.58"
					y1="796.15"
					x2="244.58"
					y2="798.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="253.94"
					y1="796.15"
					x2="253.94"
					y2="798.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="253.94"
					y1="796.15"
					x2="253.94"
					y2="798.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="253.94"
					y1="677.89"
					x2="253.94"
					y2="675.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="244.58"
					y1="677.89"
					x2="244.58"
					y2="675.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="244.58"
					y1="677.89"
					x2="253.94"
					y2="677.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="253.94"
					y1="726.56"
					x2="253.94"
					y2="729.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="244.58"
					y1="726.56"
					x2="244.58"
					y2="729.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="244.58"
					y1="726.56"
					x2="253.94"
					y2="726.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="253.94"
					y1="730.28"
					x2="253.94"
					y2="726.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="253.94"
					y1="677.89"
					x2="253.94"
					y2="674.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="244.58"
					y1="674.29"
					x2="244.58"
					y2="677.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="244.58"
					y1="726.56"
					x2="244.58"
					y2="730.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="253.94"
					y1="730.28"
					x2="244.58"
					y2="730.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<polyline
					points="254.88 725.62 253.94 725.62 253.94 729.37 254.88 729.37 254.88 725.62"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="253.94 678.83 254.88 678.83 254.88 675.08 253.94 675.08 253.94 678.83"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="244.58 725.62 243.65 725.62 243.65 729.37 244.58 729.37 244.58 725.62"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="243.65 678.83 244.58 678.83 244.58 675.08 243.65 675.08 243.65 678.83"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="254.88"
					y1="725.62"
					x2="254.88"
					y2="729.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.88"
					y1="729.37"
					x2="253.94"
					y2="729.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="253.94"
					y1="729.37"
					x2="253.94"
					y2="725.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="253.94"
					y1="725.62"
					x2="254.88"
					y2="725.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="253.94"
					y1="678.83"
					x2="253.94"
					y2="675.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="253.94"
					y1="675.08"
					x2="254.88"
					y2="675.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.88"
					y1="675.08"
					x2="254.88"
					y2="678.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.88"
					y1="678.83"
					x2="253.94"
					y2="678.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="244.58"
					y1="725.62"
					x2="244.58"
					y2="729.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="244.58"
					y1="729.37"
					x2="243.65"
					y2="729.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="243.65"
					y1="729.37"
					x2="243.65"
					y2="725.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="243.65"
					y1="725.62"
					x2="244.58"
					y2="725.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="243.65"
					y1="678.83"
					x2="243.65"
					y2="675.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="243.65"
					y1="675.08"
					x2="244.58"
					y2="675.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="244.58"
					y1="675.08"
					x2="244.58"
					y2="678.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="244.58"
					y1="678.83"
					x2="243.65"
					y2="678.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="253.94 724.69 244.58 724.69 244.58 726.09 253.94 726.09 253.94 724.69"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="253.94 678.36 244.58 678.36 244.58 679.76 253.94 679.76 253.94 678.36"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="212.81 711.53 215.13 713.85 246.9 682.08 244.58 679.76 212.81 711.53"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="244.58"
					y1="726.09"
					x2="244.58"
					y2="726.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="253.94"
					y1="726.09"
					x2="253.94"
					y2="726.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="244.58"
					y1="726.56"
					x2="253.94"
					y2="726.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="244.58"
					y1="678.36"
					x2="244.58"
					y2="677.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="253.94"
					y1="678.36"
					x2="253.94"
					y2="677.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="244.58"
					y1="677.89"
					x2="253.94"
					y2="677.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="253.94"
					y1="724.69"
					x2="244.58"
					y2="724.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="244.58"
					y1="724.69"
					x2="244.58"
					y2="726.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="244.58"
					y1="726.09"
					x2="253.94"
					y2="726.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="253.94"
					y1="726.09"
					x2="253.94"
					y2="724.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="253.94"
					y1="678.36"
					x2="244.58"
					y2="678.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="244.58"
					y1="678.36"
					x2="244.58"
					y2="679.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="244.58"
					y1="679.76"
					x2="253.94"
					y2="679.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="253.94"
					y1="679.76"
					x2="253.94"
					y2="678.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="212.81"
					y1="711.53"
					x2="215.13"
					y2="713.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.13"
					y1="713.85"
					x2="246.9"
					y2="682.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="246.9"
					y1="682.08"
					x2="244.58"
					y2="679.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="244.58"
					y1="679.76"
					x2="212.81"
					y2="711.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="244.58"
					y1="726.56"
					x2="253.94"
					y2="726.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="244.58"
					y1="726.56"
					x2="253.94"
					y2="726.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="244.58"
					y1="726.56"
					x2="244.58"
					y2="729.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="244.58"
					y1="726.56"
					x2="244.58"
					y2="729.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="253.94"
					y1="726.56"
					x2="253.94"
					y2="729.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="253.94"
					y1="726.56"
					x2="253.94"
					y2="729.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="244.58"
					y1="677.89"
					x2="253.94"
					y2="677.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="244.58"
					y1="677.89"
					x2="253.94"
					y2="677.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="244.58"
					y1="677.89"
					x2="244.58"
					y2="675.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="244.58"
					y1="677.89"
					x2="244.58"
					y2="675.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="253.94"
					y1="677.89"
					x2="253.94"
					y2="675.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="253.94"
					y1="677.89"
					x2="253.94"
					y2="675.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="218.36"
					y1="496.06"
					x2="218.36"
					y2="493.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="227.72"
					y1="496.06"
					x2="227.72"
					y2="493.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="227.72"
					y1="496.06"
					x2="218.36"
					y2="496.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="218.36"
					y1="567.2"
					x2="218.36"
					y2="570"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="227.72"
					y1="567.2"
					x2="227.72"
					y2="570"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="227.72"
					y1="567.2"
					x2="218.36"
					y2="567.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="227.72"
					y1="496.06"
					x2="227.72"
					y2="490.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<polyline
					points="217.42 566.26 217.42 570 218.36 570 218.36 566.26 217.42 566.26"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="218.36 497 218.36 493.26 217.42 493.26 217.42 497 218.36 497"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="227.72 566.26 227.72 570 228.65 570 228.65 566.26 227.72 566.26"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="228.65 497 228.65 493.26 227.72 493.26 227.72 497 228.65 497"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="217.42"
					y1="566.26"
					x2="217.42"
					y2="570"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.42"
					y1="570"
					x2="218.36"
					y2="570"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.36"
					y1="570"
					x2="218.36"
					y2="566.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.36"
					y1="566.26"
					x2="217.42"
					y2="566.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.36"
					y1="497"
					x2="218.36"
					y2="493.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.36"
					y1="493.26"
					x2="217.42"
					y2="493.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.42"
					y1="493.26"
					x2="217.42"
					y2="497"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.42"
					y1="497"
					x2="218.36"
					y2="497"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.72"
					y1="566.26"
					x2="227.72"
					y2="570"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.72"
					y1="570"
					x2="228.65"
					y2="570"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="228.65"
					y1="570"
					x2="228.65"
					y2="566.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="228.65"
					y1="566.26"
					x2="227.72"
					y2="566.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="228.65"
					y1="497"
					x2="228.65"
					y2="493.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="228.65"
					y1="493.26"
					x2="227.72"
					y2="493.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.72"
					y1="493.26"
					x2="227.72"
					y2="497"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.72"
					y1="497"
					x2="228.65"
					y2="497"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="218.36 565.33 218.36 566.73 227.72 566.73 227.72 565.33 218.36 565.33"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="218.36 496.53 218.36 497.93 227.72 497.93 227.72 496.53 218.36 496.53"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="275.37 545.59 227.72 497.93 225.4 500.25 273.05 547.9 275.37 545.59"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="227.72"
					y1="566.73"
					x2="227.72"
					y2="567.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.36"
					y1="566.73"
					x2="218.36"
					y2="567.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.72"
					y1="567.2"
					x2="218.36"
					y2="567.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.72"
					y1="496.53"
					x2="227.72"
					y2="496.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.36"
					y1="496.53"
					x2="218.36"
					y2="496.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.72"
					y1="496.06"
					x2="218.36"
					y2="496.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.36"
					y1="565.33"
					x2="227.72"
					y2="565.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.72"
					y1="565.33"
					x2="227.72"
					y2="566.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.72"
					y1="566.73"
					x2="218.36"
					y2="566.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.36"
					y1="566.73"
					x2="218.36"
					y2="565.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.36"
					y1="496.53"
					x2="227.72"
					y2="496.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.72"
					y1="496.53"
					x2="227.72"
					y2="497.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.72"
					y1="497.93"
					x2="218.36"
					y2="497.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.36"
					y1="497.93"
					x2="218.36"
					y2="496.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="275.37"
					y1="545.59"
					x2="273.05"
					y2="547.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="273.05"
					y1="547.9"
					x2="225.4"
					y2="500.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.4"
					y1="500.25"
					x2="227.72"
					y2="497.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.72"
					y1="497.93"
					x2="275.37"
					y2="545.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.72"
					y1="567.2"
					x2="218.36"
					y2="567.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="227.72"
					y1="567.2"
					x2="218.36"
					y2="567.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="227.72"
					y1="567.2"
					x2="227.72"
					y2="570"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="227.72"
					y1="567.2"
					x2="227.72"
					y2="570"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="218.36"
					y1="567.2"
					x2="218.36"
					y2="570"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="218.36"
					y1="567.2"
					x2="218.36"
					y2="570"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="227.72"
					y1="496.06"
					x2="218.36"
					y2="496.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="227.72"
					y1="496.06"
					x2="218.36"
					y2="496.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="227.72"
					y1="496.06"
					x2="227.72"
					y2="493.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="227.72"
					y1="496.06"
					x2="227.72"
					y2="493.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="218.36"
					y1="496.06"
					x2="218.36"
					y2="493.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="218.36"
					y1="496.06"
					x2="218.36"
					y2="493.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="592.95"
					y1="470.99"
					x2="592.95"
					y2="427.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="608.91"
					y1="427.58"
					x2="606.57"
					y2="427.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="608.91"
					y1="425.7"
					x2="608.91"
					y2="427.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="608.91"
					y1="418.22"
					x2="606.57"
					y2="418.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="608.91"
					y1="418.22"
					x2="608.91"
					y2="425.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="740.88"
					y1="427.58"
					x2="743.22"
					y2="427.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="740.88"
					y1="425.7"
					x2="740.88"
					y2="427.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="740.88"
					y1="418.22"
					x2="743.22"
					y2="418.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="740.88"
					y1="418.22"
					x2="740.88"
					y2="425.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="592.95"
					y1="427.58"
					x2="608.91"
					y2="427.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="740.88"
					y1="427.58"
					x2="761.05"
					y2="427.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="761.05"
					y1="418.22"
					x2="740.88"
					y2="418.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<polyline
					points="739.47 425.7 739.47 427.58 740.41 427.58 740.41 425.7 739.47 425.7"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="739.47 428.51 743.22 428.51 743.22 427.58 739.47 427.58 739.47 428.51"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="609.38 425.7 609.38 427.58 610.31 427.58 610.31 425.7 609.38 425.7"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="610.31 427.58 606.57 427.58 606.57 428.51 610.31 428.51 610.31 427.58"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="739.47 418.22 743.22 418.22 743.22 415.88 739.47 415.88 739.47 418.22"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="610.31 415.88 606.57 415.88 606.57 418.22 610.31 418.22 610.31 415.88"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="739.47"
					y1="425.7"
					x2="739.47"
					y2="427.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.47"
					y1="427.58"
					x2="740.41"
					y2="427.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.41"
					y1="427.58"
					x2="740.41"
					y2="425.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.41"
					y1="425.7"
					x2="739.47"
					y2="425.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.47"
					y1="428.51"
					x2="743.22"
					y2="428.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.22"
					y1="428.51"
					x2="743.22"
					y2="427.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.22"
					y1="427.58"
					x2="739.47"
					y2="427.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.47"
					y1="427.58"
					x2="739.47"
					y2="428.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="609.38"
					y1="425.7"
					x2="609.38"
					y2="427.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="609.38"
					y1="427.58"
					x2="610.31"
					y2="427.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="610.31"
					y1="427.58"
					x2="610.31"
					y2="425.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="610.31"
					y1="425.7"
					x2="609.38"
					y2="425.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="610.31"
					y1="427.58"
					x2="606.57"
					y2="427.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="606.57"
					y1="427.58"
					x2="606.57"
					y2="428.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="606.57"
					y1="428.51"
					x2="610.31"
					y2="428.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="610.31"
					y1="428.51"
					x2="610.31"
					y2="427.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.47"
					y1="418.22"
					x2="743.22"
					y2="418.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.22"
					y1="418.22"
					x2="743.22"
					y2="415.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.22"
					y1="415.88"
					x2="739.47"
					y2="415.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.47"
					y1="415.88"
					x2="739.47"
					y2="418.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="610.31"
					y1="415.88"
					x2="606.57"
					y2="415.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="606.57"
					y1="415.88"
					x2="606.57"
					y2="418.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="606.57"
					y1="418.22"
					x2="610.31"
					y2="418.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="610.31"
					y1="418.22"
					x2="610.31"
					y2="415.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="736.67 425.7 740.41 425.7 740.41 418.22 736.67 418.22 736.67 425.7"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="609.38 425.7 613.12 425.7 613.12 418.22 609.38 418.22 609.38 425.7"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="676.77 418.22 613.12 418.22 613.12 421.49 676.77 421.49 676.77 418.22"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="714.2 421.49 650.56 421.49 650.56 424.77 714.2 424.77 714.2 421.49"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="740.41"
					y1="418.22"
					x2="740.88"
					y2="418.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.41"
					y1="425.7"
					x2="740.88"
					y2="425.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.88"
					y1="418.22"
					x2="740.88"
					y2="425.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="609.38"
					y1="418.22"
					x2="608.91"
					y2="418.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="609.38"
					y1="425.7"
					x2="608.91"
					y2="425.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="608.91"
					y1="418.22"
					x2="608.91"
					y2="425.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.67"
					y1="425.7"
					x2="736.67"
					y2="418.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.67"
					y1="418.22"
					x2="740.41"
					y2="418.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.41"
					y1="418.22"
					x2="740.41"
					y2="425.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.41"
					y1="425.7"
					x2="736.67"
					y2="425.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="609.38"
					y1="425.7"
					x2="609.38"
					y2="418.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="609.38"
					y1="418.22"
					x2="613.12"
					y2="418.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="613.12"
					y1="418.22"
					x2="613.12"
					y2="425.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="613.12"
					y1="425.7"
					x2="609.38"
					y2="425.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="676.77"
					y1="418.22"
					x2="676.77"
					y2="421.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="676.77"
					y1="421.49"
					x2="613.12"
					y2="421.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="613.12"
					y1="421.49"
					x2="613.12"
					y2="418.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="613.12"
					y1="418.22"
					x2="676.77"
					y2="418.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="714.2"
					y1="421.49"
					x2="714.2"
					y2="424.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="714.2"
					y1="424.77"
					x2="650.56"
					y2="424.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="650.56"
					y1="424.77"
					x2="650.56"
					y2="421.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="650.56"
					y1="421.49"
					x2="714.2"
					y2="421.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.88"
					y1="418.22"
					x2="740.88"
					y2="425.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="740.88"
					y1="418.22"
					x2="740.88"
					y2="425.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="740.88"
					y1="425.7"
					x2="740.88"
					y2="427.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="740.88"
					y1="418.22"
					x2="743.22"
					y2="418.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="740.88"
					y1="425.7"
					x2="740.88"
					y2="427.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="740.88"
					y1="427.58"
					x2="743.22"
					y2="427.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="740.88"
					y1="427.58"
					x2="743.22"
					y2="427.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="608.91"
					y1="418.22"
					x2="608.91"
					y2="425.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="608.91"
					y1="418.22"
					x2="608.91"
					y2="425.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="608.91"
					y1="425.7"
					x2="608.91"
					y2="427.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="608.91"
					y1="418.22"
					x2="606.57"
					y2="418.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="608.91"
					y1="425.7"
					x2="608.91"
					y2="427.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="608.91"
					y1="427.58"
					x2="606.57"
					y2="427.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="608.91"
					y1="427.58"
					x2="606.57"
					y2="427.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="468.82"
					y1="466.69"
					x2="468.82"
					y2="469.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="478.18"
					y1="466.69"
					x2="478.18"
					y2="469.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="478.18"
					y1="466.69"
					x2="468.82"
					y2="466.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="468.82"
					y1="399.3"
					x2="468.82"
					y2="396.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="478.18"
					y1="399.3"
					x2="478.18"
					y2="396.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="478.18"
					y1="399.3"
					x2="468.82"
					y2="399.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="478.18"
					y1="470.99"
					x2="478.18"
					y2="466.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="468.82"
					y1="466.69"
					x2="468.82"
					y2="470.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<polyline
					points="467.89 400.24 468.82 400.24 468.82 396.5 467.89 396.5 467.89 400.24"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="468.82 465.76 467.89 465.76 467.89 469.5 468.82 469.5 468.82 465.76"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="478.18 400.24 479.12 400.24 479.12 396.5 478.18 396.5 478.18 400.24"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="479.12 465.76 478.18 465.76 478.18 469.5 479.12 469.5 479.12 465.76"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="467.89"
					y1="400.24"
					x2="467.89"
					y2="396.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="467.89"
					y1="396.5"
					x2="468.82"
					y2="396.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.82"
					y1="396.5"
					x2="468.82"
					y2="400.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.82"
					y1="400.24"
					x2="467.89"
					y2="400.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.82"
					y1="465.76"
					x2="468.82"
					y2="469.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.82"
					y1="469.5"
					x2="467.89"
					y2="469.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="467.89"
					y1="469.5"
					x2="467.89"
					y2="465.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="467.89"
					y1="465.76"
					x2="468.82"
					y2="465.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="478.18"
					y1="400.24"
					x2="478.18"
					y2="396.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="478.18"
					y1="396.5"
					x2="479.12"
					y2="396.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="479.12"
					y1="396.5"
					x2="479.12"
					y2="400.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="479.12"
					y1="400.24"
					x2="478.18"
					y2="400.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="479.12"
					y1="465.76"
					x2="479.12"
					y2="469.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="479.12"
					y1="469.5"
					x2="478.18"
					y2="469.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="478.18"
					y1="469.5"
					x2="478.18"
					y2="465.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="478.18"
					y1="465.76"
					x2="479.12"
					y2="465.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="468.82 401.17 478.18 401.17 478.18 399.77 468.82 399.77 468.82 401.17"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="468.82 466.23 478.18 466.23 478.18 464.82 468.82 464.82 468.82 466.23"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="523.19 419.82 520.87 417.5 475.87 462.5 478.18 464.82 523.19 419.82"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="478.18"
					y1="399.77"
					x2="478.18"
					y2="399.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.82"
					y1="399.77"
					x2="468.82"
					y2="399.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="478.18"
					y1="399.3"
					x2="468.82"
					y2="399.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="478.18"
					y1="466.23"
					x2="478.18"
					y2="466.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.82"
					y1="466.23"
					x2="468.82"
					y2="466.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="478.18"
					y1="466.69"
					x2="468.82"
					y2="466.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.82"
					y1="401.17"
					x2="478.18"
					y2="401.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="478.18"
					y1="401.17"
					x2="478.18"
					y2="399.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="478.18"
					y1="399.77"
					x2="468.82"
					y2="399.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.82"
					y1="399.77"
					x2="468.82"
					y2="401.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.82"
					y1="466.23"
					x2="478.18"
					y2="466.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="478.18"
					y1="466.23"
					x2="478.18"
					y2="464.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="478.18"
					y1="464.82"
					x2="468.82"
					y2="464.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.82"
					y1="464.82"
					x2="468.82"
					y2="466.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="523.19"
					y1="419.82"
					x2="520.87"
					y2="417.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="520.87"
					y1="417.5"
					x2="475.87"
					y2="462.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="475.87"
					y1="462.5"
					x2="478.18"
					y2="464.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="478.18"
					y1="464.82"
					x2="523.19"
					y2="419.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="478.18"
					y1="399.3"
					x2="468.82"
					y2="399.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="478.18"
					y1="399.3"
					x2="468.82"
					y2="399.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="478.18"
					y1="399.3"
					x2="478.18"
					y2="396.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="478.18"
					y1="399.3"
					x2="478.18"
					y2="396.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="468.82"
					y1="399.3"
					x2="468.82"
					y2="396.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="468.82"
					y1="399.3"
					x2="468.82"
					y2="396.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="478.18"
					y1="466.69"
					x2="468.82"
					y2="466.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="478.18"
					y1="466.69"
					x2="468.82"
					y2="466.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="478.18"
					y1="466.69"
					x2="478.18"
					y2="469.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="478.18"
					y1="466.69"
					x2="478.18"
					y2="469.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="468.82"
					y1="466.69"
					x2="468.82"
					y2="469.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="468.82"
					y1="466.69"
					x2="468.82"
					y2="469.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<polyline
					points="776.02 176.67 776.02 172.92 909.12 172.92 909.01 176.67 776.02 176.67"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="776.02"
					y1="176.67"
					x2="909.01"
					y2="176.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".12"
				/>
				<line
					x1="909.12"
					y1="172.92"
					x2="776.02"
					y2="172.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".12"
				/>
				<line
					x1="776.02"
					y1="172.92"
					x2="776.02"
					y2="176.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".12"
				/>
				<polyline
					points="949.86 219.67 946.13 219.43 946.17 213.7 945.39 208.03 943.8 202.53 941.44 197.31 938.35 192.49 934.59 188.16 930.25 184.42 925.42 181.35 920.2 179 914.69 177.43 909.01 176.67 909.12 172.92 915.34 173.74 921.38 175.45 927.11 178 932.41 181.36 937.17 185.45 941.29 190.18 944.69 195.45 947.29 201.16 949.04 207.19 949.9 213.4 949.86 219.67"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m909.12,172.92c22.95,1.34,40.88,20.34,40.88,43.33,0,1.14-.05,2.28-.14,3.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".12"
				/>
				<path
					d="m909.01,176.67c20.93,1.28,37.24,18.62,37.24,39.59,0,1.06-.04,2.12-.13,3.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".12"
				/>
				<polyline
					points="946.13 219.43 949.86 219.67 938.27 451.26 934.52 451.26 946.13 219.43"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="946.13"
					y1="219.43"
					x2="934.52"
					y2="451.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".12"
				/>
				<line
					x1="934.52"
					y1="451.26"
					x2="938.27"
					y2="451.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".12"
				/>
				<line
					x1="938.27"
					y1="451.26"
					x2="949.86"
					y2="219.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".12"
				/>
				<line
					x1="776.02"
					y1="172.92"
					x2="776.02"
					y2="187.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="776.02"
					y1="217.45"
					x2="761.05"
					y2="217.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="122.65"
					y1="187.9"
					x2="122.65"
					y2="172.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="247.32"
					y1="172.92"
					x2="247.32"
					y2="187.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="346.73"
					y1="187.9"
					x2="346.73"
					y2="172.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="467.66"
					y1="172.92"
					x2="467.66"
					y2="187.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="467.66"
					y1="187.9"
					x2="468.82"
					y2="187.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="576.12"
					y1="187.9"
					x2="576.12"
					y2="172.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<polyline
					points="305.71 516.6 304.22 519.95 303.7 523.57 304.22 527.19 305.71 530.53 307.6 532.73 309.98 534.4 315.55 536.52 322.52 537.26 329.36 535.69 335.5 536.21 341.11 538.77 342.69 539.77 345.94 540.96 349.4 540.78 350.76 540.25 354.4 540.25 354.4 538.73 352.74 538.73 354.28 536.19 354.87 533.29 354.87 513.84 353.86 510.08 351.18 507.26 347.48 506.05 347.04 506.05 344.7 506.44 341.02 508.41 335.48 510.95 329.4 511.46 322.55 509.88 315.55 510.61 309.98 512.73 307.6 514.4 305.71 516.6"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="337.59"
					y1="530.5"
					x2="337.59"
					y2="516.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.87"
					y1="513.84"
					x2="354.87"
					y2="523.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.17"
					y1="513.84"
					x2="354.17"
					y2="523.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.87"
					y1="533.29"
					x2="354.87"
					y2="523.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.17"
					y1="533.29"
					x2="354.17"
					y2="523.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="337.59"
					y1="517"
					x2="340.18"
					y2="517"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.18"
					y1="517"
					x2="340.18"
					y2="519.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.18"
					y1="519.14"
					x2="337.59"
					y2="519.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="337.59"
					y1="530.13"
					x2="340.18"
					y2="530.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.18"
					y1="530.13"
					x2="340.18"
					y2="527.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.18"
					y1="527.99"
					x2="337.59"
					y2="527.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="347.96"
					y1="538.73"
					x2="354.4"
					y2="538.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="347.96"
					y1="540.25"
					x2="354.4"
					y2="540.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.4"
					y1="540.25"
					x2="354.4"
					y2="538.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="347.96"
					y1="540.25"
					x2="347.96"
					y2="538.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="303.7"
					y1="523.57"
					x2="303.97"
					y2="521.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="303.97"
					y1="521.24"
					x2="304.57"
					y2="518.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="304.57"
					y1="518.99"
					x2="305.71"
					y2="516.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="305.71"
					y1="516.6"
					x2="307.6"
					y2="514.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="307.6"
					y1="514.4"
					x2="309.98"
					y2="512.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="309.98"
					y1="512.73"
					x2="312.68"
					y2="511.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="312.68"
					y1="511.5"
					x2="315.55"
					y2="510.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="315.55"
					y1="510.61"
					x2="320.18"
					y2="509.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="320.18"
					y1="509.8"
					x2="322.52"
					y2="509.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="322.52"
					y1="509.76"
					x2="324.85"
					y2="510.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="324.85"
					y1="510.02"
					x2="328.47"
					y2="511.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="328.47"
					y1="511.08"
					x2="331.96"
					y2="512.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="331.96"
					y1="512.72"
					x2="335.09"
					y2="514.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="335.09"
					y1="514.66"
					x2="337.59"
					y2="516.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.4"
					y1="511.46"
					x2="332.65"
					y2="511.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.65"
					y1="511.44"
					x2="335.81"
					y2="510.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="335.81"
					y1="510.9"
					x2="339.19"
					y2="509.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.19"
					y1="509.56"
					x2="341.64"
					y2="508"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="341.64"
					y1="508"
					x2="344.18"
					y2="506.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="344.18"
					y1="506.62"
					x2="346.66"
					y2="506.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="346.66"
					y1="506.07"
					x2="349.13"
					y2="506.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="349.13"
					y1="506.28"
					x2="351.37"
					y2="507.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.37"
					y1="507.24"
					x2="353.18"
					y2="508.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.18"
					y1="508.94"
					x2="354.1"
					y2="510.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.1"
					y1="510.6"
					x2="354.61"
					y2="512.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.61"
					y1="512.18"
					x2="354.87"
					y2="513.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.17"
					y1="513.84"
					x2="354.1"
					y2="513.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.1"
					y1="513.1"
					x2="353.63"
					y2="511.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.63"
					y1="511.57"
					x2="352.49"
					y2="510.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="352.49"
					y1="510.22"
					x2="350.9"
					y2="509.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="350.9"
					y1="509.38"
					x2="348.81"
					y2="508.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.81"
					y1="508.97"
					x2="346.67"
					y2="508.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="346.67"
					y1="508.88"
					x2="345.59"
					y2="508.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.59"
					y1="508.89"
					x2="344.75"
					y2="509.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="344.75"
					y1="509.34"
					x2="344.5"
					y2="509.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="344.5"
					y1="509.87"
					x2="342.83"
					y2="515.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="342.83"
					y1="515.75"
					x2="342.33"
					y2="518.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="342.33"
					y1="518.68"
					x2="342.12"
					y2="521.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="342.12"
					y1="521.63"
					x2="342.12"
					y2="523.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.36"
					y1="535.69"
					x2="332.61"
					y2="535.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.61"
					y1="535.72"
					x2="335.78"
					y2="536.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="335.78"
					y1="536.25"
					x2="339.19"
					y2="537.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.19"
					y1="537.57"
					x2="341.65"
					y2="539.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="341.65"
					y1="539.12"
					x2="344.18"
					y2="540.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="344.18"
					y1="540.51"
					x2="345.83"
					y2="540.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.83"
					y1="540.97"
					x2="347.54"
					y2="541.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="347.54"
					y1="541.07"
					x2="349.2"
					y2="540.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="349.2"
					y1="540.83"
					x2="350.76"
					y2="540.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.17"
					y1="533.29"
					x2="354.1"
					y2="534.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.1"
					y1="534.03"
					x2="353.63"
					y2="535.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.63"
					y1="535.56"
					x2="352.49"
					y2="536.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="352.49"
					y1="536.91"
					x2="350.9"
					y2="537.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="350.9"
					y1="537.76"
					x2="348.81"
					y2="538.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.81"
					y1="538.16"
					x2="346.67"
					y2="538.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="346.67"
					y1="538.25"
					x2="345.59"
					y2="538.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.59"
					y1="538.24"
					x2="344.75"
					y2="537.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="344.75"
					y1="537.79"
					x2="344.5"
					y2="537.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="344.5"
					y1="537.26"
					x2="342.83"
					y2="531.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="342.83"
					y1="531.38"
					x2="342.33"
					y2="528.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="342.33"
					y1="528.46"
					x2="342.12"
					y2="525.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="342.12"
					y1="525.5"
					x2="342.12"
					y2="523.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="303.7"
					y1="523.57"
					x2="303.97"
					y2="525.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="303.97"
					y1="525.89"
					x2="304.57"
					y2="528.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="304.57"
					y1="528.14"
					x2="305.71"
					y2="530.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="305.71"
					y1="530.53"
					x2="307.6"
					y2="532.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="307.6"
					y1="532.73"
					x2="309.98"
					y2="534.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="309.98"
					y1="534.4"
					x2="312.68"
					y2="535.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="312.68"
					y1="535.63"
					x2="315.55"
					y2="536.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="315.55"
					y1="536.52"
					x2="320.18"
					y2="537.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="320.18"
					y1="537.33"
					x2="322.52"
					y2="537.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="322.52"
					y1="537.37"
					x2="324.85"
					y2="537.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="324.85"
					y1="537.11"
					x2="328.47"
					y2="536.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="328.47"
					y1="536.06"
					x2="331.96"
					y2="534.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="331.96"
					y1="534.42"
					x2="335.09"
					y2="532.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="335.09"
					y1="532.47"
					x2="337.59"
					y2="530.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="342.83"
					y1="507.27"
					x2="342.3"
					y2="507.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="342.3"
					y1="507.64"
					x2="341.51"
					y2="508.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="341.51"
					y1="508.71"
					x2="341.33"
					y2="509.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="341.33"
					y1="509.64"
					x2="340.82"
					y2="515.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.82"
					y1="515.62"
					x2="340.58"
					y2="521.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.58"
					y1="521.61"
					x2="340.58"
					y2="523.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="342.83"
					y1="539.86"
					x2="342.3"
					y2="539.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="342.3"
					y1="539.49"
					x2="341.51"
					y2="538.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="341.51"
					y1="538.42"
					x2="341.33"
					y2="537.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="341.33"
					y1="537.49"
					x2="340.82"
					y2="531.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.82"
					y1="531.52"
					x2="340.58"
					y2="525.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.58"
					y1="525.53"
					x2="340.58"
					y2="523.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="352.74"
					y1="538.73"
					x2="353.18"
					y2="538.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.18"
					y1="538.19"
					x2="354.1"
					y2="536.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.1"
					y1="536.53"
					x2="354.61"
					y2="534.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.61"
					y1="534.95"
					x2="354.87"
					y2="533.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="354.87 501.1 354.12 501.1 354.12 504.85 354.87 504.85 354.87 501.1"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="354.87"
					y1="504.85"
					x2="354.87"
					y2="501.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.12"
					y1="504.85"
					x2="354.87"
					y2="504.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.12"
					y1="501.1"
					x2="354.12"
					y2="504.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.87"
					y1="501.1"
					x2="354.12"
					y2="501.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="354.87 546.03 354.87 542.29 354.12 542.29 354.12 546.03 354.87 546.03"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="354.12"
					y1="546.03"
					x2="354.87"
					y2="546.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.12"
					y1="542.29"
					x2="354.12"
					y2="546.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.87"
					y1="542.29"
					x2="354.12"
					y2="542.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.87"
					y1="546.03"
					x2="354.87"
					y2="542.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="354.12 502.6 348.03 502.6 348.03 503.35 354.12 503.35 354.12 502.6"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="354.12"
					y1="503.35"
					x2="354.12"
					y2="502.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.03"
					y1="503.35"
					x2="354.12"
					y2="503.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.03"
					y1="502.6"
					x2="348.03"
					y2="503.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.12"
					y1="502.6"
					x2="348.03"
					y2="502.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="354.12 544.53 354.12 543.78 348.03 543.78 348.03 544.53 354.12 544.53"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="348.03"
					y1="544.53"
					x2="354.12"
					y2="544.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.03"
					y1="543.78"
					x2="348.03"
					y2="544.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.12"
					y1="543.78"
					x2="348.03"
					y2="543.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.12"
					y1="544.53"
					x2="354.12"
					y2="543.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="349.9 503.35 348.41 503.35 348.41 543.78 349.9 543.78 349.9 503.35"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="349.9"
					y1="543.78"
					x2="349.9"
					y2="503.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.41"
					y1="543.78"
					x2="349.9"
					y2="543.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.41"
					y1="503.35"
					x2="348.41"
					y2="543.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="349.9"
					y1="503.35"
					x2="348.41"
					y2="503.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="332.05 614.08 332.05 657.34 235.17 657.34 235.17 614.08 332.05 614.08"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="332.05"
					y1="614.08"
					x2="332.05"
					y2="657.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.05"
					y1="657.34"
					x2="235.17"
					y2="657.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.17"
					y1="657.34"
					x2="235.17"
					y2="614.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.17"
					y1="614.08"
					x2="332.05"
					y2="614.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="322.53 636.09 322.56 635.7 322.66 635.33 322.82 634.97 323.03 634.65 323.29 634.38 323.59 634.15 323.93 633.99 324.29 633.89 324.66 633.85 325.03 633.89 325.38 633.99 325.72 634.15 326.02 634.38 326.29 634.65 326.5 634.97 326.66 635.33 326.75 635.7 326.78 636.09 326.75 636.48 326.66 636.86 326.5 637.21 326.29 637.53 326.02 637.81 325.72 638.03 325.38 638.19 325.03 638.29 324.66 638.33 324.29 638.29 323.93 638.19 323.59 638.03 323.29 637.81 323.03 637.53 322.82 637.21 322.66 636.86 322.56 636.48 322.53 636.09"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="322.53"
					y1="636.09"
					x2="322.56"
					y2="635.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="322.56"
					y1="635.7"
					x2="322.66"
					y2="635.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="322.66"
					y1="635.33"
					x2="322.82"
					y2="634.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="322.82"
					y1="634.97"
					x2="323.03"
					y2="634.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="323.03"
					y1="634.65"
					x2="323.29"
					y2="634.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="323.29"
					y1="634.38"
					x2="323.59"
					y2="634.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="323.59"
					y1="634.15"
					x2="323.93"
					y2="633.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="323.93"
					y1="633.99"
					x2="324.29"
					y2="633.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="324.29"
					y1="633.89"
					x2="324.66"
					y2="633.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="324.66"
					y1="633.85"
					x2="325.03"
					y2="633.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.03"
					y1="633.89"
					x2="325.38"
					y2="633.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.38"
					y1="633.99"
					x2="325.72"
					y2="634.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.72"
					y1="634.15"
					x2="326.02"
					y2="634.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="326.02"
					y1="634.38"
					x2="326.29"
					y2="634.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="326.29"
					y1="634.65"
					x2="326.5"
					y2="634.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="326.5"
					y1="634.97"
					x2="326.66"
					y2="635.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="326.66"
					y1="635.33"
					x2="326.75"
					y2="635.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="326.75"
					y1="635.7"
					x2="326.78"
					y2="636.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="326.78"
					y1="636.09"
					x2="326.75"
					y2="636.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="326.75"
					y1="636.48"
					x2="326.66"
					y2="636.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="326.66"
					y1="636.86"
					x2="326.5"
					y2="637.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="326.5"
					y1="637.21"
					x2="326.29"
					y2="637.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="326.29"
					y1="637.53"
					x2="326.02"
					y2="637.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="326.02"
					y1="637.81"
					x2="325.72"
					y2="638.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.72"
					y1="638.03"
					x2="325.38"
					y2="638.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.38"
					y1="638.19"
					x2="325.03"
					y2="638.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.03"
					y1="638.29"
					x2="324.66"
					y2="638.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="324.66"
					y1="638.33"
					x2="324.29"
					y2="638.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="324.29"
					y1="638.29"
					x2="323.93"
					y2="638.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="323.93"
					y1="638.19"
					x2="323.59"
					y2="638.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="323.59"
					y1="638.03"
					x2="323.29"
					y2="637.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="323.29"
					y1="637.81"
					x2="323.03"
					y2="637.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="323.03"
					y1="637.53"
					x2="322.82"
					y2="637.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="322.82"
					y1="637.21"
					x2="322.66"
					y2="636.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="322.66"
					y1="636.86"
					x2="322.56"
					y2="636.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="322.56"
					y1="636.48"
					x2="322.53"
					y2="636.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="334.54 638.02 331.46 637.71 331.22 637.67 330.99 637.58 330.77 637.46 326.88 636.95 326.75 636.92 326.62 636.86 326.5 636.79 326.39 636.69 326.31 636.58 326.24 636.45 326.19 636.31 326.17 636.17 326.17 636.02 326.19 635.87 326.24 635.73 326.31 635.61 326.39 635.49 326.5 635.4 326.62 635.32 326.75 635.27 326.88 635.23 330.77 634.72 330.99 634.6 331.22 634.51 331.46 634.47 334.54 634.16 334.86 634.19 335.17 634.28 335.46 634.42 335.72 634.61 335.95 634.85 336.13 635.13 336.26 635.43 336.35 635.75 336.37 636.09 336.35 636.43 336.26 636.75 336.13 637.06 335.95 637.33 335.72 637.57 335.46 637.76 335.17 637.9 334.86 637.99 334.54 638.02"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="334.54"
					y1="638.02"
					x2="331.46"
					y2="637.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="330.77"
					y1="637.46"
					x2="326.88"
					y2="636.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="326.88"
					y1="635.23"
					x2="330.77"
					y2="634.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="331.46"
					y1="634.47"
					x2="334.54"
					y2="634.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.72"
					y1="635.04"
					x2="331.62"
					y2="635.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="331.62"
					y1="637.14"
					x2="332.72"
					y2="637.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.72"
					y1="637.14"
					x2="332.72"
					y2="635.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m331.46,637.71c-.25-.02-.49-.11-.7-.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m326.88,636.95c-.41-.05-.72-.42-.72-.86s.31-.8.72-.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m330.77,634.72c.21-.14.45-.23.7-.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m334.54,634.16c1.02,0,1.84.86,1.84,1.93s-.82,1.93-1.84,1.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m331.62,637.14c-.55,0-1-.47-1-1.05s.45-1.05,1-1.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m330.77,637.46c-.44-.3-.71-.81-.71-1.37s.27-1.07.71-1.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="124.89 583.78 82.18 583.78 82.18 625.76 124.89 625.76 124.89 583.78"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="124.89"
					y1="625.76"
					x2="124.89"
					y2="624.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="124.89"
					y1="621.39"
					x2="124.89"
					y2="616.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="124.89"
					y1="614.2"
					x2="124.89"
					y2="609.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="124.89"
					y1="607.02"
					x2="124.89"
					y2="602.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="124.89"
					y1="599.83"
					x2="124.89"
					y2="595.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="124.89"
					y1="592.64"
					x2="124.89"
					y2="588.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="124.89"
					y1="585.45"
					x2="124.89"
					y2="583.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="82.18"
					y1="625.76"
					x2="84.22"
					y2="625.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="86.91"
					y1="625.76"
					x2="91.41"
					y2="625.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="94.1"
					y1="625.76"
					x2="98.59"
					y2="625.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="101.29"
					y1="625.76"
					x2="105.78"
					y2="625.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="108.48"
					y1="625.76"
					x2="112.97"
					y2="625.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="115.67"
					y1="625.76"
					x2="120.16"
					y2="625.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="122.85"
					y1="625.76"
					x2="124.89"
					y2="625.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="82.18"
					y1="583.78"
					x2="82.18"
					y2="585.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="82.18"
					y1="588.15"
					x2="82.18"
					y2="592.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="82.18"
					y1="595.33"
					x2="82.18"
					y2="599.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="82.18"
					y1="602.52"
					x2="82.18"
					y2="607.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="82.18"
					y1="609.71"
					x2="82.18"
					y2="614.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="82.18"
					y1="616.9"
					x2="82.18"
					y2="621.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="82.18"
					y1="624.09"
					x2="82.18"
					y2="625.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="124.89"
					y1="583.78"
					x2="122.85"
					y2="583.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="120.16"
					y1="583.78"
					x2="115.67"
					y2="583.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="112.97"
					y1="583.78"
					x2="108.48"
					y2="583.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="105.78"
					y1="583.78"
					x2="101.29"
					y2="583.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="98.59"
					y1="583.78"
					x2="94.1"
					y2="583.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="91.41"
					y1="583.78"
					x2="86.91"
					y2="583.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="84.22"
					y1="583.78"
					x2="82.18"
					y2="583.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="127.1 625.6 128.39 625.6 128.39 583.94 127.1 583.94 127.1 590.47 128.16 590.47 128.16 619.06 127.1 619.06 127.1 625.6"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="127.1"
					y1="619.06"
					x2="127.1"
					y2="625.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".21"
				/>
				<line
					x1="128.16"
					y1="619.06"
					x2="127.1"
					y2="619.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".21"
				/>
				<line
					x1="128.16"
					y1="590.47"
					x2="128.16"
					y2="619.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".21"
				/>
				<line
					x1="127.1"
					y1="590.47"
					x2="128.16"
					y2="590.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".21"
				/>
				<line
					x1="127.1"
					y1="583.94"
					x2="127.1"
					y2="590.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".21"
				/>
				<line
					x1="128.39"
					y1="583.94"
					x2="127.1"
					y2="583.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".21"
				/>
				<line
					x1="128.39"
					y1="625.6"
					x2="128.39"
					y2="583.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".21"
				/>
				<line
					x1="127.1"
					y1="625.6"
					x2="128.39"
					y2="625.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".21"
				/>
				<polyline
					points="127.1 627.23 127.1 582.31 124.89 582.31 124.89 627.23 127.1 627.23"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="124.89"
					y1="627.23"
					x2="127.1"
					y2="627.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".21"
				/>
				<line
					x1="124.89"
					y1="582.31"
					x2="124.89"
					y2="627.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".21"
				/>
				<line
					x1="127.1"
					y1="582.31"
					x2="124.89"
					y2="582.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".21"
				/>
				<line
					x1="127.1"
					y1="627.23"
					x2="127.1"
					y2="582.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".21"
				/>
				<line
					x1="127.1"
					y1="583.94"
					x2="128.39"
					y2="583.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="128.39"
					y1="583.94"
					x2="128.39"
					y2="625.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="128.39"
					y1="625.6"
					x2="127.1"
					y2="625.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="127.1"
					y1="582.31"
					x2="127.1"
					y2="627.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="127.1"
					y1="619.06"
					x2="128.16"
					y2="619.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="128.16"
					y1="619.06"
					x2="128.16"
					y2="590.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="128.16"
					y1="590.47"
					x2="127.1"
					y2="590.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="124.89"
					y1="582.31"
					x2="127.1"
					y2="582.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="127.1"
					y1="627.23"
					x2="124.89"
					y2="627.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="124.89"
					y1="627.23"
					x2="124.89"
					y2="582.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="133.72 821.93 133.72 759.71 64.98 759.71 64.98 821.93 133.72 821.93"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="64.98"
					y1="821.93"
					x2="133.72"
					y2="821.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="64.98"
					y1="759.71"
					x2="64.98"
					y2="821.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="133.72"
					y1="759.71"
					x2="64.98"
					y2="759.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="133.72"
					y1="821.93"
					x2="133.72"
					y2="759.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="129.04"
					y1="821.93"
					x2="129.04"
					y2="759.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="121.2 679.26 121.2 632.63 120.77 631.59 119.73 631.16 88.51 631.16 87.47 631.59 87.04 632.63 87.04 679.26 87.47 680.3 88.51 680.74 119.73 680.74 120.77 680.3 121.2 679.26"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m121.2,679.26c0,.81-.66,1.47-1.47,1.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="88.51"
					y1="680.74"
					x2="119.73"
					y2="680.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m88.51,680.74c-.81,0-1.47-.66-1.47-1.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="87.04"
					y1="632.63"
					x2="87.04"
					y2="679.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m87.04,632.63c0-.82.66-1.47,1.47-1.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="119.73"
					y1="631.16"
					x2="88.51"
					y2="631.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m119.73,631.16c.81,0,1.47.66,1.47,1.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="121.2"
					y1="679.26"
					x2="121.2"
					y2="632.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="117.51"
					y1="675.58"
					x2="117.51"
					y2="636.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="116.04"
					y1="634.84"
					x2="95.88"
					y2="634.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="94.41"
					y1="636.32"
					x2="94.41"
					y2="675.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="95.88"
					y1="677.05"
					x2="116.04"
					y2="677.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="117.51"
					y1="675.58"
					x2="117.51"
					y2="675.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m116.04,634.84c.81,0,1.47.66,1.47,1.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m94.41,636.32c0-.81.66-1.47,1.47-1.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m95.88,677.05c-.81,0-1.47-.66-1.47-1.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m117.51,675.58c0,.81-.66,1.47-1.47,1.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m103.99,655.95c0-1.22-.99-2.21-2.21-2.21s-2.21.99-2.21,2.21.99,2.21,2.21,2.21,2.21-.99,2.21-2.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="103.83 656.61 104.3 656.41 104.49 655.94 104.3 655.47 103.83 655.28 89.25 655.28 88.78 655.48 88.58 655.95 88.78 656.41 89.25 656.61 103.83 656.61"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="89.25"
					y1="656.61"
					x2="103.83"
					y2="656.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m89.25,656.61c-.37,0-.66-.29-.66-.66s.3-.66.66-.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="103.83"
					y1="655.28"
					x2="89.25"
					y2="655.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m103.83,655.28h0c.37,0,.66.29.66.66s-.3.66-.66.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="93.01 657.42 93.01 656.61 89.25 656.61 88.78 656.41 88.58 655.95 88.78 655.48 89.25 655.28 93.01 655.28 93.01 654.47 88.22 654.47 88.22 657.42 93.01 657.42"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="88.22"
					y1="657.42"
					x2="93.01"
					y2="657.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="88.22"
					y1="654.47"
					x2="88.22"
					y2="657.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="93.01"
					y1="654.47"
					x2="88.22"
					y2="654.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="93.01"
					y1="655.28"
					x2="93.01"
					y2="654.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="89.25"
					y1="655.28"
					x2="93.01"
					y2="655.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m89.25,656.61c-.37,0-.66-.29-.66-.66s.3-.66.66-.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="93.01"
					y1="656.61"
					x2="89.25"
					y2="656.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="93.01"
					y1="657.42"
					x2="93.01"
					y2="656.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="95.66 657.4 95.66 656.61 93.08 656.61 93.08 657.4 95.66 657.4"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="93.08"
					y1="657.4"
					x2="95.66"
					y2="657.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="93.08"
					y1="656.61"
					x2="93.08"
					y2="657.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="95.66"
					y1="656.61"
					x2="93.08"
					y2="656.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="95.66"
					y1="657.4"
					x2="95.66"
					y2="656.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="95.66 654.49 93.08 654.49 93.08 655.28 95.66 655.28 95.66 654.49"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="95.66"
					y1="655.28"
					x2="95.66"
					y2="654.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="93.08"
					y1="655.28"
					x2="95.66"
					y2="655.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="93.08"
					y1="654.49"
					x2="93.08"
					y2="655.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="95.66"
					y1="654.49"
					x2="93.08"
					y2="654.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="317.45 556.1 317.45 604.77 354.87 604.77 354.87 556.1 317.45 556.1"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="317.45"
					y1="556.1"
					x2="317.45"
					y2="604.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.87"
					y1="556.1"
					x2="354.87"
					y2="604.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="317.45"
					y1="604.77"
					x2="354.87"
					y2="604.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="317.45"
					y1="556.1"
					x2="354.87"
					y2="556.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.4"
					y1="556.1"
					x2="353.4"
					y2="604.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="326.33"
					y1="561.71"
					x2="326.33"
					y2="599.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="326.33"
					y1="599.15"
					x2="348.8"
					y2="599.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.8"
					y1="599.15"
					x2="348.8"
					y2="561.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.8"
					y1="561.71"
					x2="326.33"
					y2="561.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="324.86"
					y1="560.24"
					x2="324.86"
					y2="600.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="324.86"
					y1="600.63"
					x2="350.27"
					y2="600.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="350.27"
					y1="600.63"
					x2="350.27"
					y2="560.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="350.27"
					y1="560.24"
					x2="324.86"
					y2="560.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m345.94,580.43c0-1.22-.99-2.21-2.21-2.21s-2.21.99-2.21,2.21.99,2.21,2.21,2.21,2.21-.99,2.21-2.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="352.85 578.59 349.76 578.89 349.06 579.13 345.16 579.61 344.64 579.89 344.43 580.43 344.64 580.98 345.16 581.25 349.06 581.74 349.76 581.98 352.85 582.27 353.93 581.92 354.6 581 354.6 579.86 353.93 578.94 352.85 578.59"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m352.85,578.59c1.02,0,1.85.82,1.85,1.84s-.83,1.84-1.85,1.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="349.76"
					y1="581.98"
					x2="352.85"
					y2="582.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m349.76,581.98c-.25-.02-.49-.1-.7-.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.16"
					y1="581.25"
					x2="349.06"
					y2="581.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m345.16,581.25c-.41-.05-.72-.4-.72-.82s.31-.77.72-.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="349.06"
					y1="579.13"
					x2="345.16"
					y2="579.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m349.06,579.13c.21-.14.45-.22.7-.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="352.85"
					y1="578.59"
					x2="349.76"
					y2="578.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.02"
					y1="581.44"
					x2="349.92"
					y2="581.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="349.92"
					y1="579.43"
					x2="351.02"
					y2="579.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.02"
					y1="579.43"
					x2="351.02"
					y2="581.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m349.92,581.44c-.56,0-1-.45-1-1s.45-1,1-1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m349.06,581.74c-.45-.29-.71-.78-.71-1.31s.27-1.02.71-1.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="272.58"
					y1="785.89"
					x2="260.58"
					y2="785.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="260.58"
					y1="785.89"
					x2="260.58"
					y2="753.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="272.58"
					y1="792.75"
					x2="272.58"
					y2="746.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="303.41"
					y1="746.49"
					x2="303.41"
					y2="792.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="303.41"
					y1="792.75"
					x2="257.16"
					y2="792.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="257.16"
					y1="746.49"
					x2="303.41"
					y2="746.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="258.01"
					y1="792.75"
					x2="258.01"
					y2="746.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="272.58"
					y1="753.35"
					x2="260.58"
					y2="753.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="257.16"
					y1="792.75"
					x2="257.16"
					y2="746.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="122.65"
					y1="172.92"
					x2="247.32"
					y2="172.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="122.65"
					y1="187.9"
					x2="247.32"
					y2="187.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="346.73"
					y1="172.92"
					x2="467.66"
					y2="172.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="467.66"
					y1="187.9"
					x2="346.73"
					y2="187.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.12"
					y1="172.92"
					x2="722.89"
					y2="172.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="722.89"
					y1="187.9"
					x2="576.12"
					y2="187.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="776.02"
					y1="217.45"
					x2="776.02"
					y2="344.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="133.72"
					y1="761.78"
					x2="137.81"
					y2="761.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="137.81"
					y1="761.78"
					x2="137.81"
					y2="763.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="137.81"
					y1="763.86"
					x2="133.72"
					y2="763.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="127.1"
					y1="821.93"
					x2="127.1"
					y2="817.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="127.1"
					y1="814.63"
					x2="127.1"
					y2="810.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="127.1"
					y1="807.44"
					x2="127.1"
					y2="802.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="127.1"
					y1="800.26"
					x2="127.1"
					y2="795.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="127.1"
					y1="793.07"
					x2="127.1"
					y2="788.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="127.1"
					y1="785.88"
					x2="127.1"
					y2="781.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="127.1"
					y1="778.69"
					x2="127.1"
					y2="774.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="127.1"
					y1="771.5"
					x2="127.1"
					y2="767.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="127.1"
					y1="764.31"
					x2="127.1"
					y2="759.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="127.1"
					y1="759.71"
					x2="127.1"
					y2="581.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="127.1"
					y1="581.07"
					x2="82.18"
					y2="581.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.05"
					y1="217.45"
					x2="761.05"
					y2="340.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="298.27"
					y1="785.89"
					x2="298.27"
					y2="753.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="298.27"
					y1="753.35"
					x2="276"
					y2="753.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276"
					y1="753.35"
					x2="276"
					y2="785.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276"
					y1="785.89"
					x2="298.27"
					y2="785.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="130.85 740.6 130.85 684.44 82.18 684.44 82.18 740.6 130.85 740.6"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="130.85"
					y1="740.6"
					x2="130.85"
					y2="684.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="82.18"
					y1="740.6"
					x2="82.18"
					y2="684.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="83.65"
					y1="740.6"
					x2="83.65"
					y2="684.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="130.85"
					y1="740.6"
					x2="82.18"
					y2="740.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="130.85"
					y1="684.44"
					x2="82.18"
					y2="684.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="128.64"
					y1="736.92"
					x2="128.64"
					y2="688.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="128.64"
					y1="688.13"
					x2="127.16"
					y2="686.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="127.16"
					y1="686.66"
					x2="85.86"
					y2="686.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="85.86"
					y1="686.66"
					x2="84.39"
					y2="688.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="84.39"
					y1="688.13"
					x2="84.39"
					y2="736.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="84.39"
					y1="736.92"
					x2="85.86"
					y2="738.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="85.86"
					y1="738.39"
					x2="127.16"
					y2="738.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="127.16"
					y1="738.39"
					x2="128.64"
					y2="736.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m126.05,726.56c0-4.07-3.3-7.37-7.37-7.37s-7.37,3.3-7.37,7.37,3.3,7.37,7.37,7.37,7.37-3.3,7.37-7.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m99.87,726.56c0-3.05-2.47-5.53-5.53-5.53s-5.53,2.48-5.53,5.53,2.47,5.53,5.53,5.53,5.53-2.48,5.53-5.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m124.21,698.48c0-3.05-2.47-5.53-5.53-5.53s-5.53,2.47-5.53,5.53,2.47,5.53,5.53,5.53,5.53-2.48,5.53-5.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m101.72,698.48c0-4.07-3.3-7.37-7.37-7.37s-7.37,3.3-7.37,7.37,3.3,7.37,7.37,7.37,7.37-3.3,7.37-7.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.64"
					y1="759.71"
					x2="104.64"
					y2="758"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.64"
					y1="755.3"
					x2="104.64"
					y2="750.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.64"
					y1="748.11"
					x2="104.64"
					y2="743.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.64"
					y1="740.93"
					x2="104.64"
					y2="736.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.64"
					y1="733.74"
					x2="104.64"
					y2="729.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.64"
					y1="726.55"
					x2="104.64"
					y2="722.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.64"
					y1="719.36"
					x2="104.64"
					y2="714.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.64"
					y1="712.17"
					x2="104.64"
					y2="707.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.64"
					y1="704.98"
					x2="104.64"
					y2="700.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.64"
					y1="697.8"
					x2="104.64"
					y2="693.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.64"
					y1="690.61"
					x2="104.64"
					y2="686.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.64"
					y1="683.42"
					x2="104.64"
					y2="678.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.64"
					y1="676.23"
					x2="104.64"
					y2="671.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.64"
					y1="669.04"
					x2="104.64"
					y2="664.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.64"
					y1="661.86"
					x2="104.64"
					y2="657.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.64"
					y1="654.67"
					x2="104.64"
					y2="650.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.64"
					y1="647.48"
					x2="104.64"
					y2="642.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.64"
					y1="640.29"
					x2="104.64"
					y2="635.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.64"
					y1="633.1"
					x2="104.64"
					y2="628.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.64"
					y1="625.91"
					x2="104.64"
					y2="621.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.64"
					y1="618.73"
					x2="104.64"
					y2="614.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.64"
					y1="611.54"
					x2="104.64"
					y2="607.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.64"
					y1="604.35"
					x2="104.64"
					y2="599.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.64"
					y1="597.16"
					x2="104.64"
					y2="592.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.64"
					y1="589.97"
					x2="104.64"
					y2="585.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.64"
					y1="582.79"
					x2="104.64"
					y2="581.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
			</g>
			<g id="walls">
				<polygon
					points="941.46 451.27 941.46 485.96 369.85 485.96 369.85 836.91 213.66 836.91 213.66 821.94 244.58 821.94 244.58 796.16 253.95 796.16 253.95 800.07 314.17 800.07 314.17 739.64 253.95 739.64 253.95 743.74 244.58 743.74 244.58 726.56 253.95 726.56 253.95 730.28 299.77 730.28 299.77 674.29 253.95 674.29 253.95 677.89 244.58 677.89 244.58 674.29 218.36 674.29 218.36 567.2 227.71 567.2 227.71 664.93 339.03 664.93 339.03 607.25 354.87 607.25 354.87 490.69 227.71 490.69 227.71 496.07 218.36 496.07 218.36 406.92 364.23 406.92 364.23 470.99 468.82 470.99 468.82 466.69 478.18 466.69 478.18 470.99 583.58 470.99 583.58 418.21 608.91 418.21 608.91 427.57 592.95 427.57 592.95 470.99 761.05 470.99 761.05 427.57 740.88 427.57 740.88 418.21 761.05 418.21 761.05 414.47 776.02 414.47 776.02 451.27 941.46 451.27"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.23"
				/>
				<polygon
					points="776.02 172.92 776.02 217.45 761.05 217.45 761.05 187.9 722.89 187.9 722.89 172.92 776.02 172.92"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.23"
				/>
				<polygon
					points="142.53 821.94 142.53 836.91 50 836.91 50 199.13 50.41 194.58 51.59 190.17 53.51 186.02 56.14 182.28 59.36 179.05 63.11 176.43 67.24 174.5 71.66 173.32 76.21 172.92 122.65 172.92 122.65 187.9 76.21 187.9 73.3 188.28 70.59 189.4 68.27 191.19 66.48 193.51 65.36 196.22 64.98 199.13 64.98 519.54 82.17 519.54 82.17 759.72 64.98 759.72 64.98 821.94 142.53 821.94"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.23"
				/>
				<polygon
					points="346.73 172.92 346.73 187.9 247.32 187.9 247.32 172.92 346.73 172.92 346.73 172.92"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.23"
				/>
				<polygon
					points="576.12 172.92 576.12 187.9 478.18 187.9 478.18 399.3 468.82 399.3 468.82 187.9 467.66 187.9 467.66 172.92 576.12 172.92"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.23"
				/>
			</g>
			<g id="text">
				<path d="m84.01,608.69v-8.68h2.99c.68,0,1.19.04,1.55.12.5.11.92.32,1.27.62.46.39.8.88,1.02,1.49.23.6.34,1.29.34,2.06,0,.66-.08,1.24-.23,1.75-.15.51-.35.93-.59,1.27-.24.33-.51.59-.79.79-.28.19-.63.33-1.04.43-.4.1-.87.15-1.39.15h-3.13Zm1.15-1.02h1.85c.57,0,1.02-.05,1.34-.16.33-.11.59-.26.78-.45.27-.27.48-.64.63-1.1.15-.46.23-1.02.23-1.68,0-.91-.15-1.6-.45-2.09-.3-.49-.66-.82-1.08-.98-.31-.12-.8-.18-1.49-.18h-1.82v6.63Zm9.13,1.02l-2.3-8.68h1.18l1.32,5.69c.14.6.26,1.19.37,1.78.22-.93.35-1.46.39-1.6l1.65-5.86h1.39l1.24,4.39c.31,1.09.54,2.11.68,3.07.11-.55.25-1.18.43-1.89l1.36-5.58h1.15l-2.38,8.68h-1.11l-1.83-6.61c-.15-.55-.24-.89-.27-1.02-.09.4-.18.74-.25,1.02l-1.84,6.61h-1.17Z" />
				<path d="m96.61,796.02h-1.22l-1.46-2.45c-.13-.23-.26-.42-.39-.58-.13-.16-.26-.29-.39-.4-.13-.1-.27-.17-.43-.22-.15-.05-.32-.07-.51-.07h-.84v3.72h-1.02v-8.74h2.61c.38,0,.73.05,1.05.15.33.09.61.24.84.43.24.2.43.44.56.73.13.29.2.63.2,1.02,0,.3-.05.59-.14.84-.09.25-.22.48-.39.68-.17.2-.37.37-.61.51-.24.14-.5.25-.8.32v.02c.15.07.27.14.38.23.11.08.21.18.31.29.1.11.19.24.29.39.1.14.21.31.32.5l1.64,2.63Zm-5.24-7.82v3.17h1.39c.26,0,.49-.04.71-.12.22-.08.41-.19.57-.33.16-.15.28-.32.37-.53.09-.21.13-.45.13-.71,0-.47-.15-.83-.46-1.09-.3-.26-.74-.4-1.31-.4h-1.4Zm11.21,4.94h-4.41c.02.69.2,1.23.56,1.61s.85.57,1.48.57c.7,0,1.35-.23,1.94-.69v.94c-.55.4-1.27.6-2.18.6s-1.57-.28-2.08-.85c-.5-.57-.76-1.37-.76-2.4,0-.97.27-1.76.82-2.37.55-.61,1.24-.92,2.05-.92s1.45.26,1.9.79c.45.53.67,1.26.67,2.2v.52Zm-1.02-.85c0-.58-.14-1.03-.42-1.35-.27-.32-.65-.48-1.14-.48s-.87.17-1.2.51c-.33.34-.53.78-.61,1.32h3.37Zm5.51-4.65c-.2-.11-.42-.16-.66-.16-.7,0-1.05.44-1.05,1.32v.96h1.46v.85h-1.46v5.39h-.99v-5.39h-1.07v-.85h1.07v-1.01c0-.65.19-1.17.57-1.55.38-.38.85-.57,1.41-.57.3,0,.55.04.73.11v.9Z" />
				<path d="m108.11,796.16c-.19,0-.35-.07-.48-.2-.13-.13-.2-.29-.2-.48s.07-.35.2-.48c.13-.14.29-.21.48-.21s.35.07.49.21c.13.13.2.29.2.48s-.07.35-.2.48c-.13.13-.3.2-.49.2Z" />
				<path d="m251.36,587.87v-13.57h3.86c1.17,0,2.1.29,2.79.86.69.57,1.03,1.32,1.03,2.24,0,.77-.21,1.44-.62,2.01-.42.57-.99.97-1.72,1.21v.04c.91.11,1.65.45,2.2,1.04.55.58.82,1.34.82,2.27,0,1.16-.42,2.1-1.25,2.82-.83.72-1.88,1.08-3.15,1.08h-3.96Zm1.59-12.13v4.38h1.63c.87,0,1.56-.21,2.05-.62.5-.42.75-1.02.75-1.78,0-1.32-.87-1.98-2.6-1.98h-1.83Zm0,5.81v4.88h2.16c.93,0,1.66-.22,2.17-.66.52-.44.78-1.05.78-1.82,0-1.6-1.09-2.4-3.27-2.4h-1.83Zm16.24,6.32h-1.55v-1.51h-.04c-.68,1.16-1.67,1.74-2.98,1.74-.97,0-1.72-.26-2.27-.77-.54-.51-.81-1.19-.81-2.03,0-1.81,1.07-2.86,3.2-3.16l2.91-.41c0-1.65-.67-2.47-2-2.47-1.17,0-2.22.4-3.16,1.19v-1.59c.95-.61,2.05-.91,3.29-.91,2.28,0,3.42,1.2,3.42,3.62v6.3Zm-1.55-4.9l-2.34.32c-.72.1-1.26.28-1.63.54-.37.25-.55.7-.55,1.35,0,.47.17.86.5,1.16.34.3.79.44,1.35.44.77,0,1.4-.27,1.9-.8.5-.54.76-1.23.76-2.05v-.97Zm8.97,4.81c-.37.2-.85.3-1.45.3-1.7,0-2.55-.95-2.55-2.84v-5.73h-1.67v-1.32h1.67v-2.37l1.55-.5v2.87h2.44v1.32h-2.44v5.46c0,.65.11,1.11.33,1.39.22.28.59.42,1.1.42.39,0,.73-.11,1.01-.32v1.32Zm10.12.09h-1.55v-5.58c0-2.02-.75-3.03-2.25-3.03-.76,0-1.39.29-1.91.88-.52.58-.78,1.33-.78,2.24v5.49h-1.55v-14.35h1.55v6.26h.04c.74-1.22,1.8-1.84,3.18-1.84,2.18,0,3.27,1.32,3.27,3.95v5.97Z" />
				<path d="m800.44,316.91v5.13h-1.59v-13.57h3.73c1.45,0,2.57.35,3.37,1.06.8.71,1.2,1.7,1.2,2.99s-.44,2.34-1.33,3.16c-.88.82-2.08,1.23-3.59,1.23h-1.79Zm0-7v5.56h1.67c1.1,0,1.93-.25,2.51-.75.58-.5.87-1.21.87-2.13,0-1.79-1.06-2.69-3.18-2.69h-1.86Zm15.85,12.13h-1.55v-1.51h-.04c-.68,1.16-1.67,1.74-2.98,1.74-.97,0-1.72-.26-2.27-.77-.54-.51-.81-1.19-.81-2.03,0-1.81,1.07-2.86,3.2-3.16l2.91-.41c0-1.65-.67-2.47-2-2.47-1.17,0-2.22.4-3.16,1.19v-1.59c.95-.61,2.05-.91,3.29-.91,2.28,0,3.42,1.21,3.42,3.62v6.3Zm-1.55-4.9l-2.34.32c-.72.1-1.26.28-1.63.54-.37.25-.55.7-.55,1.35,0,.47.17.86.5,1.16.34.3.79.44,1.35.44.77,0,1.4-.27,1.9-.8.5-.54.76-1.23.76-2.05v-.97Zm8.84,4.81c-.37.2-.85.3-1.45.3-1.7,0-2.55-.95-2.55-2.84v-5.73h-1.67v-1.32h1.67v-2.37l1.55-.5v2.87h2.44v1.32h-2.44v5.46c0,.65.11,1.11.33,1.39.22.28.59.42,1.1.42.39,0,.73-.11,1.01-.32v1.32Zm2.73-12.06c-.28,0-.51-.09-.71-.28-.2-.19-.29-.43-.29-.72s.1-.53.29-.72c.2-.2.43-.29.71-.29s.52.1.72.29c.2.19.3.43.3.72s-.1.51-.3.71c-.2.2-.44.29-.72.29Zm.76,12.15h-1.55v-9.69h1.55v9.69Zm7.05.23c-1.43,0-2.58-.45-3.44-1.35-.85-.91-1.28-2.11-1.28-3.61,0-1.63.44-2.9,1.33-3.81.89-.91,2.09-1.37,3.61-1.37s2.57.44,3.38,1.33c.81.89,1.22,2.12,1.22,3.7s-.44,2.79-1.32,3.72c-.87.93-2.04,1.39-3.51,1.39Zm.11-8.84c-1,0-1.79.34-2.37,1.02-.58.68-.87,1.61-.87,2.8s.29,2.05.88,2.72c.59.66,1.37.99,2.36.99s1.77-.32,2.31-.97c.54-.65.81-1.57.81-2.77s-.27-2.15-.81-2.8c-.54-.66-1.31-.98-2.31-.98Z" />
				<polygon points="847.4 308.47 840.89 324.29 839.44 324.29 845.93 308.47 847.4 308.47" />
				<path d="m848.98,322.04v-13.57h3.86c1.17,0,2.1.29,2.79.86.69.57,1.03,1.32,1.03,2.24,0,.77-.21,1.44-.62,2.01-.42.57-.99.97-1.72,1.21v.04c.91.11,1.65.45,2.2,1.04.55.58.82,1.34.82,2.27,0,1.16-.42,2.1-1.25,2.82s-1.88,1.08-3.15,1.08h-3.96Zm1.59-12.13v4.38h1.63c.87,0,1.56-.21,2.05-.62.5-.42.75-1.02.75-1.78,0-1.32-.87-1.98-2.6-1.98h-1.83Zm0,5.81v4.88h2.16c.93,0,1.66-.22,2.17-.66.52-.44.78-1.05.78-1.82,0-1.6-1.09-2.4-3.27-2.4h-1.83Zm16.24,6.32h-1.55v-1.51h-.04c-.68,1.16-1.67,1.74-2.98,1.74-.97,0-1.72-.26-2.27-.77-.54-.51-.81-1.19-.81-2.03,0-1.81,1.07-2.86,3.2-3.16l2.91-.41c0-1.65-.67-2.47-2-2.47-1.17,0-2.22.4-3.16,1.19v-1.59c.95-.61,2.05-.91,3.29-.91,2.28,0,3.42,1.21,3.42,3.62v6.3Zm-1.55-4.9l-2.34.32c-.72.1-1.26.28-1.63.54-.37.25-.55.7-.55,1.35,0,.47.17.86.5,1.16.34.3.79.44,1.35.44.77,0,1.4-.27,1.9-.8.5-.54.76-1.23.76-2.05v-.97Zm6.03,4.9h-1.55v-14.35h1.55v14.35Zm9.74-.44c-.74.45-1.63.67-2.65.67-1.38,0-2.5-.45-3.35-1.34-.85-.9-1.27-2.07-1.27-3.5,0-1.6.46-2.88,1.37-3.84.91-.97,2.14-1.46,3.66-1.46.85,0,1.6.16,2.25.47v1.59c-.72-.5-1.49-.76-2.31-.76-.99,0-1.8.36-2.44,1.07-.63.71-.95,1.64-.95,2.79s.3,2.03.89,2.69c.6.66,1.4.98,2.4.98.85,0,1.64-.28,2.38-.84v1.48Zm6.39.67c-1.43,0-2.58-.45-3.44-1.35-.85-.91-1.28-2.11-1.28-3.61,0-1.63.44-2.9,1.33-3.81.89-.91,2.09-1.37,3.61-1.37s2.57.44,3.38,1.33c.81.89,1.22,2.12,1.22,3.7s-.44,2.79-1.32,3.72c-.87.93-2.04,1.39-3.51,1.39Zm.11-8.84c-1,0-1.79.34-2.37,1.02-.58.67-.87,1.61-.87,2.8s.29,2.05.88,2.72c.59.66,1.37.99,2.36.99s1.77-.32,2.31-.97c.54-.65.81-1.57.81-2.77s-.27-2.15-.81-2.8c-.54-.66-1.31-.98-2.31-.98Zm15.23,8.61h-1.55v-5.53c0-2.06-.75-3.09-2.25-3.09-.78,0-1.42.29-1.93.88-.5.58-.76,1.32-.76,2.2v5.53h-1.55v-9.69h1.55v1.61h.04c.73-1.22,1.79-1.84,3.18-1.84,1.06,0,1.87.34,2.43,1.03.56.68.84,1.67.84,2.96v5.92Zm10.63-9.69l-4.46,11.24c-.79,2.01-1.91,3.01-3.35,3.01-.4,0-.74-.04-1.01-.12v-1.39c.33.11.64.17.92.17.78,0,1.37-.47,1.76-1.4l.78-1.84-3.79-9.67h1.72l2.62,7.46c.03.09.1.34.2.74h.06c.03-.15.09-.39.19-.72l2.75-7.48h1.61Z" />
				<path d="m176.35,756.19h-7.19v-13.57h6.89v1.44h-5.3v4.51h4.9v1.43h-4.9v4.75h5.6v1.44Zm10.46,0h-1.55v-5.53c0-2.06-.75-3.09-2.25-3.09-.78,0-1.42.29-1.93.88-.5.58-.76,1.32-.76,2.2v5.53h-1.55v-9.69h1.55v1.61h.04c.73-1.22,1.79-1.84,3.18-1.84,1.06,0,1.87.34,2.43,1.03.56.68.84,1.67.84,2.96v5.92Zm7.43-.09c-.37.2-.85.3-1.45.3-1.7,0-2.55-.95-2.55-2.84v-5.73h-1.67v-1.32h1.67v-2.37l1.55-.5v2.87h2.44v1.32h-2.44v5.46c0,.65.11,1.11.33,1.39.22.28.59.42,1.1.42.39,0,.73-.11,1.01-.32v1.32Zm7.14-8.02c-.27-.21-.66-.31-1.17-.31-.66,0-1.22.31-1.67.94-.44.62-.66,1.48-.66,2.56v4.94h-1.55v-9.69h1.55v2h.04c.22-.68.56-1.21,1.01-1.59.45-.38.96-.58,1.52-.58.4,0,.71.04.93.13v1.61Zm9.42-1.57l-4.46,11.24c-.79,2.01-1.91,3.01-3.35,3.01-.4,0-.74-.04-1.01-.12v-1.39c.33.11.64.17.92.17.78,0,1.37-.47,1.76-1.4l.78-1.84-3.79-9.67h1.72l2.62,7.46c.03.09.1.34.2.74h.06c.03-.15.09-.39.19-.72l2.75-7.48h1.61Z" />
				<path d="m582.05,301.74v-13.57h3.86c1.17,0,2.1.29,2.79.86s1.03,1.32,1.03,2.24c0,.77-.21,1.44-.62,2.01-.42.57-.99.97-1.72,1.21v.04c.91.11,1.65.45,2.2,1.04.55.58.82,1.34.82,2.27,0,1.16-.42,2.1-1.25,2.82s-1.88,1.08-3.15,1.08h-3.96Zm1.59-12.13v4.38h1.63c.87,0,1.56-.21,2.05-.62.5-.42.75-1.02.75-1.78,0-1.32-.87-1.98-2.6-1.98h-1.83Zm0,5.81v4.88h2.16c.93,0,1.66-.22,2.17-.66.52-.44.78-1.05.78-1.82,0-1.6-1.09-2.4-3.27-2.4h-1.83Zm17.08,1.86h-6.84c.03,1.08.32,1.91.87,2.5s1.32.88,2.29.88c1.09,0,2.09-.36,3.01-1.08v1.46c-.85.62-1.98.93-3.38.93s-2.44-.44-3.23-1.32c-.78-.88-1.17-2.12-1.17-3.72,0-1.51.43-2.73,1.28-3.68.86-.95,1.92-1.43,3.19-1.43s2.25.41,2.94,1.23,1.04,1.96,1.04,3.42v.81Zm-1.59-1.32c0-.9-.22-1.59-.65-2.09-.42-.5-1.01-.75-1.77-.75s-1.35.26-1.86.79-.83,1.21-.95,2.05h5.23Zm12.19,5.77h-1.55v-1.65h-.04c-.72,1.25-1.83,1.87-3.33,1.87-1.22,0-2.19-.43-2.92-1.3-.73-.87-1.09-2.05-1.09-3.55,0-1.6.4-2.89,1.21-3.85.81-.97,1.88-1.45,3.23-1.45s2.3.52,2.91,1.57h.04v-6h1.55v14.35Zm-1.55-4.38v-1.43c0-.78-.26-1.44-.78-1.99-.52-.54-1.17-.81-1.97-.81-.95,0-1.69.35-2.23,1.04s-.81,1.65-.81,2.88c0,1.12.26,2,.78,2.65.52.64,1.22.97,2.1.97s1.56-.31,2.1-.94c.54-.62.81-1.41.81-2.37Zm9.73-3.74c-.27-.21-.66-.31-1.17-.31-.66,0-1.22.31-1.67.94-.44.62-.66,1.48-.66,2.56v4.94h-1.55v-9.69h1.55v2h.04c.22-.68.56-1.21,1.01-1.59.45-.38.96-.58,1.52-.58.4,0,.71.04.93.13v1.61Zm5.72,8.35c-1.43,0-2.58-.45-3.44-1.35-.85-.91-1.28-2.11-1.28-3.61,0-1.63.44-2.9,1.33-3.81.89-.91,2.09-1.37,3.61-1.37s2.57.44,3.38,1.33c.81.89,1.22,2.12,1.22,3.7s-.44,2.79-1.32,3.72c-.87.93-2.04,1.39-3.51,1.39Zm.11-8.84c-1,0-1.79.34-2.37,1.02-.58.68-.87,1.61-.87,2.8s.29,2.05.88,2.72c.59.66,1.37.99,2.36.99s1.77-.32,2.31-.97c.54-.65.81-1.57.81-2.77s-.27-2.15-.81-2.8c-.54-.66-1.31-.98-2.31-.98Zm11.23,8.84c-1.43,0-2.58-.45-3.44-1.35-.85-.91-1.28-2.11-1.28-3.61,0-1.63.44-2.9,1.33-3.81.89-.91,2.09-1.37,3.61-1.37s2.57.44,3.38,1.33c.81.89,1.22,2.12,1.22,3.7s-.44,2.79-1.32,3.72c-.87.93-2.04,1.39-3.51,1.39Zm.11-8.84c-1,0-1.79.34-2.37,1.02-.58.68-.87,1.61-.87,2.8s.29,2.05.88,2.72c.59.66,1.37.99,2.36.99s1.77-.32,2.31-.97c.54-.65.81-1.57.81-2.77s-.27-2.15-.81-2.8c-.54-.66-1.31-.98-2.31-.98Zm20.94,8.61h-1.55v-5.56c0-1.07-.17-1.85-.5-2.33-.33-.48-.88-.72-1.67-.72-.66,0-1.23.3-1.69.91-.46.61-.69,1.33-.69,2.18v5.53h-1.55v-5.75c0-1.91-.74-2.86-2.2-2.86-.68,0-1.24.29-1.68.86-.44.57-.66,1.31-.66,2.22v5.53h-1.55v-9.69h1.55v1.53h.04c.69-1.17,1.69-1.76,3.01-1.76.66,0,1.24.19,1.73.56.49.37.83.85,1.01,1.45.72-1.34,1.79-2.01,3.22-2.01,2.13,0,3.2,1.32,3.2,3.95v5.97Z" />
				<path d="m585.93,321.85h-1.13v-8.52c-.09.09-.22.19-.39.3-.17.11-.35.22-.56.33-.21.11-.43.21-.66.31-.23.1-.45.17-.67.23v-1.14c.25-.07.51-.16.78-.28.28-.12.55-.25.82-.39.27-.15.53-.3.76-.45.24-.16.44-.32.62-.47h.43v10.08Zm7.94-7.28c0-.3-.05-.57-.14-.79-.09-.22-.22-.41-.39-.56-.16-.15-.35-.26-.57-.34-.22-.07-.46-.11-.72-.11-.22,0-.44.03-.65.09-.21.06-.42.14-.62.25-.2.11-.39.23-.58.38-.18.15-.36.31-.52.49v-1.21c.32-.31.67-.54,1.06-.7.39-.17.87-.25,1.44-.25.4,0,.78.06,1.12.18.34.11.64.28.89.51.25.22.45.5.59.83.15.33.22.71.22,1.14,0,.39-.05.74-.14,1.06-.09.32-.22.61-.41.89-.18.28-.41.55-.68.8-.28.26-.6.52-.97.78-.46.33-.85.61-1.15.85-.3.23-.54.45-.72.66-.17.2-.3.41-.37.61-.07.2-.1.44-.1.7h4.91v1.01h-6.09v-.49c0-.42.05-.79.14-1.11.09-.32.24-.63.45-.91s.49-.58.83-.87c.34-.29.76-.61,1.26-.98.36-.26.66-.5.89-.74.24-.23.44-.47.58-.7s.25-.47.31-.71c.06-.24.1-.5.1-.77Z" />
				<rect x="597.29" y="311.99" width="1" height="3.07" />
				<path d="m606.31,312.64c-.15.26-.33.59-.55.98-.21.39-.44.83-.67,1.31-.24.49-.48,1.01-.73,1.57s-.48,1.14-.69,1.73c-.22.6-.41,1.2-.57,1.82-.16.61-.28,1.21-.35,1.8h-1.21c.08-.59.21-1.19.38-1.8.17-.61.37-1.22.58-1.8.22-.59.45-1.16.69-1.71.24-.55.48-1.05.71-1.51.23-.46.44-.86.63-1.21.19-.35.35-.63.46-.83h-4.95v-1.02h6.27v.65Z" />
				<path d="m609.1,311.99v3.07h-1v-3.07h1Zm2.28,0v3.07h-1v-3.07h1Z" />
				<path d="m622.66,314.81l-2.37,3.56,2.33,3.48h-1.31l-1.38-2.28c-.09-.14-.19-.32-.31-.54h-.03s-.13.22-.32.54l-1.41,2.28h-1.3l2.4-3.45-2.3-3.59h1.31l1.36,2.41c.1.18.2.36.3.55h.03l1.76-2.96h1.25Z" />
				<path d="m631.69,321.85h-1.13v-8.52c-.09.09-.22.19-.39.3-.17.11-.35.22-.56.33-.21.11-.43.21-.66.31-.23.1-.45.17-.67.23v-1.14c.25-.07.51-.16.78-.28.28-.12.55-.25.82-.39.27-.15.53-.3.76-.45.24-.16.44-.32.62-.47h.43v10.08Zm9.65-4.97c0,.83-.08,1.56-.23,2.19-.15.64-.36,1.18-.65,1.62-.28.44-.63.77-1.04,1-.41.22-.87.34-1.4.34-.5,0-.94-.11-1.33-.32-.39-.22-.71-.54-.98-.96-.27-.42-.47-.93-.61-1.53-.14-.61-.21-1.31-.21-2.09,0-.86.07-1.62.21-2.28.15-.66.36-1.21.64-1.66.28-.45.63-.79,1.04-1.01.42-.23.89-.34,1.43-.34,2.07,0,3.1,1.69,3.1,5.06Zm-1.16.11c0-2.81-.67-4.21-2-4.21-1.41,0-2.11,1.43-2.11,4.29,0,2.66.69,4,2.07,4s2.04-1.36,2.04-4.07Z" />
				<rect x="643.05" y="311.99" width="1" height="3.07" />
				<path d="m650.97,311.99v6.51h1.27v1.03h-1.27v2.32h-1.11v-2.32h-4.64v-.98c.43-.49.87-1,1.31-1.55.44-.55.86-1.12,1.26-1.69.4-.57.78-1.14,1.11-1.7.34-.57.63-1.11.87-1.63h1.2Zm-4.48,6.51h3.36v-4.83c-.34.6-.67,1.14-.98,1.61-.31.47-.6.9-.88,1.29-.28.39-.54.73-.79,1.05-.25.31-.49.61-.72.89Z" />
				<path d="m654.86,311.99v3.07h-1v-3.07h1Zm2.28,0v3.07h-1v-3.07h1Z" />
				<path d="m152.24,678.47h-2.21l-5.24-6.21c-.2-.23-.32-.39-.36-.47h-.04v6.68h-1.59v-13.57h1.59v6.38h.04c.09-.14.21-.29.36-.46l5.07-5.91h1.98l-5.82,6.51,6.23,7.06Zm2.37-12.15c-.28,0-.51-.09-.71-.28-.2-.19-.29-.43-.29-.72s.1-.53.29-.72c.2-.2.43-.29.71-.29s.52.1.72.29c.2.19.3.43.3.72s-.1.51-.3.71c-.2.2-.44.29-.72.29Zm.76,12.15h-1.55v-9.69h1.55v9.69Zm7.62-.09c-.37.2-.85.3-1.45.3-1.7,0-2.55-.95-2.55-2.84v-5.73h-1.67v-1.32h1.67v-2.37l1.55-.5v2.87h2.44v1.32h-2.44v5.46c0,.65.11,1.11.33,1.39.22.28.59.42,1.1.42.39,0,.73-.11,1.01-.32v1.32Zm8.67-.35c-.74.45-1.63.67-2.65.67-1.38,0-2.5-.45-3.35-1.34-.85-.9-1.27-2.07-1.27-3.5,0-1.6.46-2.88,1.37-3.84.91-.97,2.14-1.46,3.66-1.46.85,0,1.6.16,2.25.47v1.59c-.72-.5-1.49-.76-2.31-.76-.99,0-1.8.36-2.44,1.07-.63.71-.95,1.64-.95,2.79s.3,2.03.89,2.69c.6.66,1.4.98,2.4.98.85,0,1.64-.28,2.38-.84v1.48Zm10.38.44h-1.55v-5.58c0-2.02-.75-3.03-2.25-3.03-.76,0-1.39.29-1.91.88-.52.58-.78,1.33-.78,2.24v5.49h-1.55v-14.35h1.55v6.26h.04c.74-1.22,1.8-1.84,3.18-1.84,2.18,0,3.27,1.32,3.27,3.95v5.97Zm10.7-4.46h-6.84c.03,1.08.32,1.91.87,2.5.56.59,1.32.88,2.29.88,1.09,0,2.09-.36,3.01-1.08v1.46c-.85.62-1.98.93-3.38.93s-2.44-.44-3.23-1.32c-.78-.88-1.17-2.12-1.17-3.72,0-1.51.43-2.73,1.28-3.68.86-.95,1.92-1.43,3.19-1.43s2.25.41,2.94,1.23c.69.82,1.04,1.96,1.04,3.42v.81Zm-1.59-1.32c0-.9-.22-1.59-.65-2.09-.42-.5-1.01-.75-1.77-.75s-1.35.26-1.86.79c-.51.52-.83,1.21-.95,2.05h5.23Zm11.97,5.77h-1.55v-5.53c0-2.06-.75-3.09-2.25-3.09-.78,0-1.42.29-1.93.88-.5.58-.76,1.32-.76,2.2v5.53h-1.55v-9.69h1.55v1.61h.04c.73-1.22,1.79-1.84,3.18-1.84,1.06,0,1.87.34,2.43,1.03.56.68.84,1.67.84,2.96v5.92Z" />
				<path d="m190.32,296.09h-7.04v-13.57h1.59v12.13h5.45v1.44Zm2.67-12.15c-.28,0-.51-.09-.71-.28-.2-.19-.29-.43-.29-.72s.1-.53.29-.72c.2-.2.43-.29.71-.29s.52.1.72.29c.2.19.3.43.3.72s-.1.51-.3.71c-.2.2-.44.29-.72.29Zm.76,12.15h-1.55v-9.69h1.55v9.69Zm10.75-9.69l-3.86,9.69h-1.52l-3.67-9.69h1.7l2.46,7.04c.18.52.3.97.34,1.35h.04c.06-.49.16-.92.3-1.32l2.57-7.08h1.64Zm2.45-2.46c-.28,0-.51-.09-.71-.28-.2-.19-.29-.43-.29-.72s.1-.53.29-.72c.2-.2.43-.29.71-.29s.52.1.72.29c.2.19.3.43.3.72s-.1.51-.3.71c-.2.2-.44.29-.72.29Zm.76,12.15h-1.55v-9.69h1.55v9.69Zm11.17,0h-1.55v-5.53c0-2.06-.75-3.09-2.25-3.09-.78,0-1.42.29-1.93.88-.5.58-.76,1.32-.76,2.2v5.53h-1.55v-9.69h1.55v1.61h.04c.73-1.22,1.79-1.84,3.18-1.84,1.06,0,1.87.34,2.43,1.03.56.68.84,1.67.84,2.96v5.92Zm11.19-.78c0,3.56-1.7,5.34-5.11,5.34-1.2,0-2.25-.23-3.14-.68v-1.55c1.09.61,2.13.91,3.12.91,2.38,0,3.58-1.27,3.58-3.8v-1.06h-.04c-.74,1.24-1.85,1.85-3.33,1.85-1.2,0-2.18-.43-2.91-1.29-.73-.86-1.1-2.02-1.1-3.47,0-1.65.39-2.96,1.18-3.93.79-.97,1.88-1.46,3.26-1.46s2.27.52,2.91,1.57h.04v-1.34h1.55v8.91Zm-1.55-3.61v-1.43c0-.77-.26-1.43-.79-1.98-.52-.55-1.16-.82-1.94-.82-.96,0-1.71.35-2.25,1.05-.54.69-.81,1.67-.81,2.92,0,1.08.26,1.94.78,2.59.52.64,1.21.97,2.07.97s1.58-.31,2.12-.93c.55-.62.82-1.41.82-2.38Z" />
				<polygon points="239.32 282.52 232.81 298.34 231.36 298.34 237.86 282.52 239.32 282.52" />
				<path d="m240.9,296.09v-13.57h3.75c4.78,0,7.17,2.2,7.17,6.61,0,2.09-.67,3.78-2,5.05-1.32,1.27-3.1,1.9-5.33,1.9h-3.6Zm1.59-12.13v10.69h2.03c1.78,0,3.16-.48,4.15-1.43s1.49-2.3,1.49-4.05c0-3.48-1.85-5.21-5.55-5.21h-2.12Zm12.52-.02c-.28,0-.51-.09-.71-.28-.2-.19-.29-.43-.29-.72s.1-.53.29-.72c.2-.2.43-.29.71-.29s.52.1.72.29c.2.19.3.43.3.72s-.1.51-.3.71c-.2.2-.44.29-.72.29Zm.76,12.15h-1.55v-9.69h1.55v9.69Zm11.12,0h-1.55v-5.53c0-2.06-.75-3.09-2.25-3.09-.78,0-1.42.29-1.93.88-.5.58-.76,1.32-.76,2.2v5.53h-1.55v-9.69h1.55v1.61h.04c.73-1.22,1.79-1.84,3.18-1.84,1.06,0,1.87.34,2.43,1.03.56.68.84,1.67.84,2.96v5.92Zm3.66-12.15c-.28,0-.51-.09-.71-.28-.2-.19-.29-.43-.29-.72s.1-.53.29-.72c.2-.2.43-.29.71-.29s.52.1.72.29c.2.19.3.43.3.72s-.1.51-.3.71c-.2.2-.44.29-.72.29Zm.76,12.15h-1.55v-9.69h1.55v9.69Zm11.12,0h-1.55v-5.53c0-2.06-.75-3.09-2.25-3.09-.78,0-1.42.29-1.93.88-.5.58-.76,1.32-.76,2.2v5.53h-1.55v-9.69h1.55v1.61h.04c.73-1.22,1.79-1.84,3.18-1.84,1.06,0,1.87.34,2.43,1.03.56.68.84,1.67.84,2.96v5.92Zm11.14-.78c0,3.56-1.7,5.34-5.11,5.34-1.2,0-2.25-.23-3.14-.68v-1.55c1.09.61,2.13.91,3.12.91,2.38,0,3.58-1.27,3.58-3.8v-1.06h-.04c-.74,1.24-1.85,1.85-3.33,1.85-1.2,0-2.18-.43-2.91-1.29-.73-.86-1.1-2.02-1.1-3.47,0-1.65.39-2.96,1.18-3.93.79-.97,1.88-1.46,3.26-1.46s2.27.52,2.91,1.57h.04v-1.34h1.55v8.91Zm-1.55-3.61v-1.43c0-.77-.26-1.43-.79-1.98-.52-.55-1.16-.82-1.94-.82-.96,0-1.71.35-2.25,1.05-.54.69-.81,1.67-.81,2.92,0,1.08.26,1.94.78,2.59.52.64,1.21.97,2.07.97s1.58-.31,2.12-.93c.55-.62.82-1.41.82-2.38Z" />
				<path d="m312.13,296.09h-1.89l-2.27-3.8c-.21-.35-.41-.65-.61-.9-.2-.25-.4-.46-.61-.62-.2-.16-.42-.27-.66-.34-.23-.08-.5-.11-.79-.11h-1.31v5.77h-1.59v-13.57h4.05c.59,0,1.14.08,1.64.23.5.15.94.37,1.31.67.37.3.66.68.87,1.14.21.45.31.97.31,1.58,0,.47-.07.91-.22,1.31-.14.39-.34.74-.61,1.05-.26.31-.57.57-.95.79-.37.21-.78.38-1.24.5v.04c.23.1.42.22.59.35.17.13.33.28.48.45s.3.38.44.61c.15.22.32.48.5.78l2.55,4.08Zm-8.14-12.13v4.92h2.16c.4,0,.76-.06,1.1-.18.34-.12.63-.29.88-.51.25-.23.44-.5.58-.82.14-.33.21-.69.21-1.1,0-.73-.24-1.29-.71-1.69-.47-.41-1.15-.62-2.03-.62h-2.18Zm13.78,12.36c-1.43,0-2.58-.45-3.44-1.35-.85-.91-1.28-2.11-1.28-3.61,0-1.63.44-2.9,1.33-3.81.89-.91,2.09-1.37,3.61-1.37s2.57.44,3.38,1.33c.81.89,1.22,2.12,1.22,3.7s-.44,2.79-1.32,3.72c-.87.93-2.04,1.39-3.51,1.39Zm.11-8.84c-1,0-1.79.34-2.37,1.02-.58.68-.87,1.61-.87,2.8s.29,2.05.88,2.72c.59.66,1.37.99,2.36.99s1.77-.32,2.31-.97c.54-.65.81-1.57.81-2.77s-.27-2.15-.81-2.8c-.54-.66-1.31-.98-2.31-.98Zm11.18,8.84c-1.43,0-2.58-.45-3.44-1.35-.85-.91-1.28-2.11-1.28-3.61,0-1.63.44-2.9,1.33-3.81.89-.91,2.09-1.37,3.61-1.37s2.57.44,3.38,1.33c.81.89,1.22,2.12,1.22,3.7s-.44,2.79-1.32,3.72c-.87.93-2.04,1.39-3.51,1.39Zm.11-8.84c-1,0-1.79.34-2.37,1.02-.58.68-.87,1.61-.87,2.8s.29,2.05.88,2.72c.59.66,1.37.99,2.36.99s1.77-.32,2.31-.97c.54-.65.81-1.57.81-2.77s-.27-2.15-.81-2.8c-.54-.66-1.31-.98-2.31-.98Zm20.89,8.61h-1.55v-5.56c0-1.07-.17-1.85-.5-2.33-.33-.48-.88-.72-1.67-.72-.66,0-1.23.3-1.69.91-.46.61-.69,1.33-.69,2.18v5.53h-1.55v-5.75c0-1.91-.74-2.86-2.2-2.86-.68,0-1.24.29-1.68.86-.44.57-.66,1.31-.66,2.22v5.53h-1.55v-9.69h1.55v1.53h.04c.69-1.17,1.69-1.76,3.01-1.76.66,0,1.24.19,1.73.56.49.37.83.85,1.01,1.45.72-1.34,1.79-2.01,3.22-2.01,2.13,0,3.2,1.32,3.2,3.95v5.97Z" />
				<path d="m236.44,316.2h-1.13v-8.52c-.09.09-.22.19-.39.3-.17.11-.35.22-.56.33-.21.11-.43.21-.66.31-.23.1-.45.17-.67.23v-1.14c.25-.07.51-.16.78-.28.28-.12.55-.25.82-.39.27-.15.53-.3.76-.45.24-.16.44-.32.62-.47h.43v10.08Zm3.25-2.75c0-.26.04-.52.12-.78.08-.27.2-.51.35-.74.16-.23.35-.44.57-.63.23-.19.49-.34.78-.45-.43-.24-.77-.54-1.02-.91-.25-.38-.38-.79-.38-1.25,0-.36.07-.7.21-1,.14-.31.34-.57.58-.8.25-.22.54-.4.88-.52.34-.13.71-.19,1.1-.19s.77.06,1.11.19c.34.13.63.3.88.53.25.22.44.49.58.8.14.31.21.64.21,1,0,.45-.13.87-.38,1.25-.25.37-.59.68-1,.91.28.11.54.26.76.45.22.19.41.4.56.63.16.23.28.48.36.74.08.26.12.52.12.78,0,.43-.08.83-.23,1.18-.16.36-.38.66-.66.92-.28.25-.62.45-1.01.59-.39.14-.82.21-1.29.21s-.9-.07-1.29-.21c-.39-.14-.73-.34-1.01-.59-.28-.26-.51-.56-.67-.92-.16-.36-.23-.75-.23-1.18Zm1.22-.1c0,.31.05.58.14.83.1.25.23.46.4.63.17.17.38.31.63.41.25.09.52.14.82.14s.55-.05.8-.14c.24-.1.45-.23.63-.41.18-.17.32-.39.41-.63.1-.25.15-.52.15-.83,0-.28-.05-.53-.14-.77-.09-.24-.22-.46-.4-.64-.17-.18-.38-.33-.63-.43-.24-.11-.52-.16-.82-.16-.28,0-.55.05-.79.15-.24.1-.45.23-.63.41-.17.17-.31.39-.41.63-.1.24-.15.51-.15.8Zm.35-4.57c0,.23.04.45.12.65.09.2.2.37.35.52.15.15.33.26.52.35.2.08.41.12.63.12s.44-.04.63-.13c.2-.09.38-.2.52-.35.15-.15.26-.33.35-.52.09-.2.13-.42.13-.65s-.04-.46-.13-.66c-.08-.2-.2-.38-.34-.52-.15-.15-.32-.26-.52-.34-.2-.09-.41-.13-.64-.13-.24,0-.47.04-.67.13-.2.09-.37.21-.52.36-.14.15-.25.32-.33.52-.08.2-.12.42-.12.65Z" />
				<rect x="247.8" y="306.34" width="1" height="3.07" />
				<path d="m256.89,311.23c0,.83-.08,1.56-.23,2.19-.15.64-.36,1.18-.65,1.62-.28.44-.63.77-1.04,1-.41.22-.87.34-1.4.34-.5,0-.94-.11-1.33-.32-.39-.22-.71-.54-.98-.96-.27-.42-.47-.93-.61-1.53-.14-.61-.21-1.31-.21-2.09,0-.86.07-1.62.21-2.28.15-.66.36-1.21.64-1.66.28-.45.63-.79,1.04-1.01.42-.23.89-.34,1.43-.34,2.07,0,3.1,1.69,3.1,5.06Zm-1.16.11c0-2.81-.67-4.21-2-4.21-1.41,0-2.11,1.43-2.11,4.29,0,2.66.69,4,2.07,4s2.04-1.36,2.04-4.07Z" />
				<path d="m259.61,306.34v3.07h-1v-3.07h1Zm2.28,0v3.07h-1v-3.07h1Z" />
				<path d="m273.17,309.16l-2.37,3.56,2.33,3.48h-1.31l-1.38-2.28c-.09-.14-.19-.32-.31-.54h-.03s-.13.22-.32.54l-1.41,2.28h-1.3l2.4-3.45-2.3-3.59h1.31l1.36,2.41c.1.18.2.36.3.55h.03l1.76-2.96h1.25Z" />
				<path d="m284.13,310.68c0,.9-.09,1.71-.27,2.41-.18.7-.44,1.3-.78,1.79-.34.49-.76.86-1.26,1.11-.5.25-1.06.38-1.69.38s-1.22-.11-1.72-.34v-1.08c.55.31,1.13.46,1.75.46.44,0,.84-.09,1.19-.28.35-.18.65-.45.89-.8.24-.35.43-.79.56-1.3.13-.51.19-1.1.19-1.77h-.03c-.42.85-1.16,1.27-2.2,1.27-.42,0-.81-.07-1.16-.22-.35-.15-.66-.36-.91-.63-.26-.28-.46-.6-.6-.98-.14-.38-.21-.79-.21-1.25,0-.49.08-.93.23-1.33.16-.4.38-.75.66-1.04.28-.29.62-.52,1-.68.39-.16.81-.24,1.27-.24.5,0,.93.1,1.31.3.39.2.71.49.97.87.26.38.46.85.6,1.41.14.56.21,1.2.21,1.92Zm-1.22-1.01c0-.38-.05-.73-.15-1.04-.1-.31-.23-.58-.41-.8-.17-.22-.38-.4-.63-.52-.24-.12-.5-.19-.78-.19s-.52.06-.76.17c-.23.11-.44.26-.61.45-.17.19-.3.42-.41.69-.1.27-.14.56-.14.87,0,.35.05.66.14.94.1.28.23.51.41.7.17.19.38.33.63.43.25.1.52.15.82.15.26,0,.51-.05.74-.14.23-.1.44-.23.61-.4.17-.17.31-.37.41-.59.1-.23.15-.47.15-.74Z" />
				<rect x="285.95" y="306.34" width="1" height="3.07" />
				<path d="m288.64,313.45c0-.26.04-.52.12-.78.08-.27.2-.51.35-.74.16-.23.35-.44.57-.63.23-.19.49-.34.78-.45-.43-.24-.77-.54-1.02-.91-.25-.38-.38-.79-.38-1.25,0-.36.07-.7.21-1,.14-.31.34-.57.58-.8.25-.22.54-.4.88-.52.34-.13.71-.19,1.1-.19s.77.06,1.11.19c.34.13.63.3.88.53s.44.49.58.8c.14.31.21.64.21,1,0,.45-.13.87-.38,1.25-.25.37-.59.68-1,.91.28.11.54.26.76.45.22.19.41.4.56.63.16.23.28.48.36.74.08.26.12.52.12.78,0,.43-.08.83-.23,1.18-.16.36-.38.66-.66.92-.28.25-.62.45-1.01.59-.39.14-.82.21-1.29.21s-.9-.07-1.29-.21c-.39-.14-.73-.34-1.01-.59-.28-.26-.51-.56-.67-.92-.16-.36-.23-.75-.23-1.18Zm1.22-.1c0,.31.05.58.14.83.1.25.23.46.4.63.17.17.38.31.63.41.25.09.52.14.82.14s.55-.05.8-.14c.24-.1.45-.23.63-.41.18-.17.32-.39.41-.63.1-.25.15-.52.15-.83,0-.28-.05-.53-.14-.77-.09-.24-.22-.46-.4-.64s-.38-.33-.63-.43c-.24-.11-.52-.16-.82-.16-.28,0-.55.05-.79.15-.24.1-.45.23-.63.41-.17.17-.31.39-.41.63-.1.24-.15.51-.15.8Zm.35-4.57c0,.23.04.45.12.65.09.2.2.37.35.52.15.15.33.26.52.35.2.08.41.12.63.12s.44-.04.63-.13c.2-.09.38-.2.52-.35.15-.15.26-.33.35-.52.09-.2.13-.42.13-.65s-.04-.46-.13-.66c-.08-.2-.2-.38-.34-.52s-.32-.26-.52-.34c-.2-.09-.41-.13-.64-.13-.24,0-.47.04-.67.13-.2.09-.37.21-.52.36-.14.15-.25.32-.33.52-.08.2-.12.42-.12.65Z" />
				<path d="m297.76,306.34v3.07h-1v-3.07h1Zm2.28,0v3.07h-1v-3.07h1Z" />
				<path d="m286.14,766.42l-2.23,7.9h-1.09l-1.63-5.78c-.07-.25-.11-.51-.13-.8h-.02c-.02.27-.07.54-.14.79l-1.64,5.79h-1.07l-2.31-7.9h1.02l1.68,6.06c.07.25.11.52.13.79h.03c.02-.19.08-.46.17-.79l1.75-6.06h.89l1.68,6.11c.06.21.1.46.13.74h.02c.01-.19.06-.44.15-.76l1.61-6.08h1Z" />
				<polygon points="290.75 766.42 286.96 775.63 286.12 775.63 289.9 766.42 290.75 766.42" />
				<path d="m291.67,774.32v-7.9h2.18c2.78,0,4.18,1.28,4.18,3.85,0,1.22-.39,2.2-1.16,2.94-.77.74-1.81,1.11-3.1,1.11h-2.09Zm.93-7.06v6.23h1.18c1.04,0,1.84-.28,2.42-.83.58-.55.87-1.34.87-2.36,0-2.02-1.08-3.04-3.23-3.04h-1.23Z" />
			</g>
		</g>
	)
}

export default PlanB
